export default {
  'TSG Hoffenheim': {
    displayName: 'TSG Hoffenheim',
    logoUrl: 'soccer/tsg_hoffenheim.webp',
  },
  'FSV Mainz': {
    displayName: 'FSV Mainz',
    logoUrl: 'soccer/fsv_mainz.webp',
  },
  'Borussia Monchengladbach': {
    displayName: 'Borussia Monchengladbach',
    logoUrl: 'soccer/borussia_monchengladbach.webp',
  },
  '1. FC Heidenheim': {
    displayName: '1. FC Heidenheim',
    logoUrl: 'soccer/fc_heidenheim.webp',
  },
  'Hamburger SV': {
    displayName: 'Hamburger SV',
    logoUrl: 'soccer/hamburger_sv.webp',
  },
  'FC Augsburg': {
    displayName: 'FC Augsburg',
    logoUrl: 'soccer/fc_augsburg.webp',
  },
  'Bayer Leverkusen': {
    displayName: 'Bayer Leverkusen',
    logoUrl: 'soccer/bayer_leverkusen.webp',
  },
  'VfL Wolfsburg': {
    displayName: 'VfL Wolfsburg',
    logoUrl: 'soccer/vfl_wolfsburg.webp',
  },
  'VFL Wolfsburg': {
    displayName: 'VFL Wolfsburg',
    logoUrl: 'soccer/vfl_wolfsburg.webp',
  },
  'VfB Stuttgart': {
    displayName: 'VfB Stuttgart',
    logoUrl: 'soccer/vfb_stuttgart.webp',
  },
  'Borussia Dortmund': {
    displayName: 'Borussia Dortmund',
    logoUrl: 'soccer/borussia_dortmund.webp',
  },
  'SC Freiburg': {
    displayName: 'SC Freiburg',
    logoUrl: 'soccer/sc_freiburg.webp',
  },
  'Bayern Munich': {
    displayName: 'Bayern Munich',
    logoUrl: 'soccer/bayern_munich.webp',
  },
  'Eintracht Frankfurt': {
    displayName: 'Eintracht Frankfurt',
    logoUrl: 'soccer/eintracht_frankfurt.webp',
  },
  '1. FC Cologne': {
    displayName: '1. FC Cologne',
    logoUrl: 'soccer/fc_cologne.webp',
  },
  'Werder Bremen': {
    displayName: 'Werder Bremen',
    logoUrl: 'soccer/werder_bremen.webp',
  },
  'RB Leipzig': {
    displayName: 'RB Leipzig',
    logoUrl: 'soccer/rb_leipzig.webp',
  },
  'Union Berlin': {
    displayName: 'Union Berlin',
    logoUrl: 'soccer/union_berlin.webp',
  },
  'FC St. Pauli': {
    displayName: 'FC St. Pauli',
    logoUrl: 'soccer/fc_st_pauli.webp',
  },
  'SC Paderborn 07': {
    displayName: 'SC Paderborn 07',
    logoUrl: 'soccer/sc_paderborn_07.webp',
  },
  'Chelsea FC': {
    displayName: 'Chelsea FC',
    logoUrl: 'soccer/chelsea_fc.webp',
  },
  'Burnley FC': {
    displayName: 'Burnley FC',
    logoUrl: 'soccer/burnley_fc.webp',
  },
  'Nottingham Forest': {
    displayName: 'Nottingham Forest',
    logoUrl: 'soccer/nottingham_forest.webp',
  },
  'Liverpool FC': {
    displayName: 'Liverpool FC',
    logoUrl: 'soccer/liverpool_fc.webp',
  },
  'Crystal Palace': {
    displayName: 'Crystal Palace',
    logoUrl: 'soccer/crystal_palace.webp',
  },
  'Wolverhampton Wanderers': {
    displayName: 'Wolverhampton Wanderers',
    logoUrl: 'soccer/wolverhampton_wanderers.webp',
  },
  'West Ham United': {
    displayName: 'West Ham United',
    logoUrl: 'soccer/west_ham_united.webp',
  },
  'AFC Bournemouth': {
    displayName: 'AFC Bournemouth',
    logoUrl: 'soccer/afc_bournemouth.webp',
  },
  'Sunderland AFC': {
    displayName: 'Sunderland AFC',
    logoUrl: 'soccer/sunderland_afc.webp',
  },
  'Fulham FC': {
    displayName: 'Fulham FC',
    logoUrl: 'soccer/fulham_fc.webp',
  },
  'Brentford FC': {
    displayName: 'Brentford FC',
    logoUrl: 'soccer/brentford_fc.webp',
  },
  'Brighton & Hove Albion': {
    displayName: 'Brighton & Hove Albion',
    logoUrl: 'soccer/brighton__hove_albion.webp',
  },
  'Manchester City': {
    displayName: 'Manchester City',
    logoUrl: 'soccer/manchester_city.webp',
  },
  'Newcastle United': {
    displayName: 'Newcastle United',
    logoUrl: 'soccer/newcastle_united.webp',
  },
  'Aston Villa': {
    displayName: 'Aston Villa',
    logoUrl: 'soccer/aston_villa.webp',
  },
  'Leeds United': {
    displayName: 'Leeds United',
    logoUrl: 'soccer/leeds_united.webp',
  },
  'Tottenham Hotspur': {
    displayName: 'Tottenham Hotspur',
    logoUrl: 'soccer/tottenham_hotspur.webp',
  },
  'Arsenal FC': {
    displayName: 'Arsenal FC',
    logoUrl: 'soccer/arsenal_fc.webp',
  },
  'Everton FC': {
    displayName: 'Everton FC',
    logoUrl: 'soccer/everton_fc.webp',
  },
  'Manchester United': {
    displayName: 'Manchester United',
    logoUrl: 'soccer/manchester_united.webp',
  },
  'Genoa CFC': {
    displayName: 'Genoa CFC',
    logoUrl: 'soccer/genoa_cfc.webp',
  },
  'Cagliari Calcio': {
    displayName: 'Cagliari Calcio',
    logoUrl: 'soccer/cagliari_calcio.webp',
  },
  'Bologna FC': {
    displayName: 'Bologna FC',
    logoUrl: 'soccer/bologna_fc.webp',
  },
  'Udinese Calcio': {
    displayName: 'Udinese Calcio',
    logoUrl: 'soccer/udinese_calcio.webp',
  },
  'Juventus Turin': {
    displayName: 'Juventus Turin',
    logoUrl: 'soccer/juventus_turin.webp',
  },
  'ACF Fiorentina': {
    displayName: 'ACF Fiorentina',
    logoUrl: 'soccer/acf_fiorentina.webp',
  },
  'Atalanta BC': {
    displayName: 'Atalanta BC',
    logoUrl: 'soccer/atalanta_bc.webp',
  },
  'SSC Napoli': {
    displayName: 'SSC Napoli',
    logoUrl: 'soccer/ssc_napoli.webp',
  },
  'Parma Calcio': {
    displayName: 'Parma Calcio',
    logoUrl: 'soccer/parma_calcio.webp',
  },
  'Hellas Verona': {
    displayName: 'Hellas Verona',
    logoUrl: 'soccer/hellas_verona.webp',
  },
  'AS Roma': {
    displayName: 'AS Roma',
    logoUrl: 'soccer/as_roma.webp',
  },
  'US Cremonese': {
    displayName: 'US Cremonese',
    logoUrl: 'soccer/us_cremonese.webp',
  },
  'US Lecce': {
    displayName: 'US Lecce',
    logoUrl: 'soccer/us_lecce.webp',
  },
  'Lazio Rome': {
    displayName: 'Lazio Rome',
    logoUrl: 'soccer/lazio_rome.webp',
  },
  'AC Milan': {
    displayName: 'AC Milan',
    logoUrl: 'soccer/ac_milan.webp',
  },
  'Inter Milano': {
    displayName: 'Inter Milano',
    logoUrl: 'soccer/inter_milano.webp',
  },
  'Como 1907': {
    displayName: 'Como 1907',
    logoUrl: 'soccer/como_1907.webp',
  },
  'Torino FC': {
    displayName: 'Torino FC',
    logoUrl: 'soccer/torino_fc.webp',
  },
  'Pisa SC': {
    displayName: 'Pisa SC',
    logoUrl: 'soccer/pisa_sc.webp',
  },
  'Sassuolo Calcio': {
    displayName: 'Sassuolo Calcio',
    logoUrl: 'soccer/sassuolo_calcio.webp',
  },
  'Los Angeles FC': {
    displayName: 'Los Angeles FC',
    logoUrl: 'soccer/los_angeles_fc.webp',
  },
  'Vancouver Whitecaps FC': {
    displayName: 'Vancouver Whitecaps FC',
    logoUrl: 'soccer/vancouver_whitecaps_fc.webp',
  },
  'Inter Miami CF': {
    displayName: 'Inter Miami CF',
    logoUrl: 'soccer/inter_miami_cf.webp',
  },
  'FC Cincinnati': {
    displayName: 'FC Cincinnati',
    logoUrl: 'soccer/fc_cincinnati.webp',
  },
  'New York City FC': {
    displayName: 'New York City FC',
    logoUrl: 'soccer/new_york_city_fc.webp',
  },
  'Philadelphia Union': {
    displayName: 'Philadelphia Union',
    logoUrl: 'soccer/philadelphia_union.webp',
  },
  'Minnesota United FC': {
    displayName: 'Minnesota United FC',
    logoUrl: 'soccer/minnesota_united_fc.webp',
  },
  'San Diego FC': {
    displayName: 'San Diego FC',
    logoUrl: 'soccer/san_diego_fc.webp',
  },
  'Levante UD': {
    displayName: 'Levante UD',
    logoUrl: 'soccer/levante_ud.webp',
  },
  'Valencia CF': {
    displayName: 'Valencia CF',
    logoUrl: 'soccer/valencia_cf.webp',
  },
  'RC Celta de Vigo': {
    displayName: 'RC Celta de Vigo',
    logoUrl: 'soccer/rc_celta_de_vigo.webp',
  },
  'Deportivo Alaves': {
    displayName: 'Deportivo Alaves',
    logoUrl: 'soccer/deportivo_alaves.webp',
  },
  'Athletic Bilbao': {
    displayName: 'Athletic Bilbao',
    logoUrl: 'soccer/athletic_bilbao.webp',
  },
  'FC Barcelona': {
    displayName: 'FC Barcelona',
    logoUrl: 'soccer/fc_barcelona.webp',
  },
  'Real Sociedad San Sebastian': {
    displayName: 'Real Sociedad San Sebastian',
    logoUrl: 'soccer/real_sociedad_san_sebastian.webp',
  },
  'CA Osasuna': {
    displayName: 'CA Osasuna',
    logoUrl: 'soccer/ca_osasuna.webp',
  },
  'RCD Mallorca': {
    displayName: 'RCD Mallorca',
    logoUrl: 'soccer/rcd_mallorca.webp',
  },
  'Villarreal CF': {
    displayName: 'Villarreal CF',
    logoUrl: 'soccer/villarreal_cf.webp',
  },
  'Rayo Vallecano': {
    displayName: 'Rayo Vallecano',
    logoUrl: 'soccer/rayo_vallecano.webp',
  },
  'Real Oviedo': {
    displayName: 'Real Oviedo',
    logoUrl: 'soccer/real_oviedo.webp',
  },
  'Girona FC': {
    displayName: 'Girona FC',
    logoUrl: 'soccer/girona_fc.webp',
  },
  'Real Betis Seville': {
    displayName: 'Real Betis Seville',
    logoUrl: 'soccer/real_betis_seville.webp',
  },
  'Atletico Madrid': {
    displayName: 'Atletico Madrid',
    logoUrl: 'soccer/atletico_madrid.webp',
  },
  'Getafe CF': {
    displayName: 'Getafe CF',
    logoUrl: 'soccer/getafe_cf.webp',
  },
  'Elche CF': {
    displayName: 'Elche CF',
    logoUrl: 'soccer/elche_cf.webp',
  },
  'Real Madrid': {
    displayName: 'Real Madrid',
    logoUrl: 'soccer/real_madrid.webp',
  },
  'Sevilla FC': {
    displayName: 'Sevilla FC',
    logoUrl: 'soccer/sevilla_fc.webp',
  },
  'Espanyol Barcelona': {
    displayName: 'Espanyol Barcelona',
    logoUrl: 'soccer/espanyol_barcelona.webp',
  },
  'Olympique Marseille': {
    displayName: 'Olympique Marseille',
    logoUrl: 'soccer/olympique_marseille.webp',
  },
  'OGC Nice': {
    displayName: 'OGC Nice',
    logoUrl: 'soccer/ogc_nice.webp',
  },
  'Strasbourg Alsace': {
    displayName: 'Strasbourg Alsace',
    logoUrl: 'soccer/strasbourg_alsace.webp',
  },
  'RC Lens': {
    displayName: 'RC Lens',
    logoUrl: 'soccer/rc_lens.webp',
  },
  'AS Monaco': {
    displayName: 'AS Monaco',
    logoUrl: 'soccer/as_monaco.webp',
  },
  'Stade Rennais FC': {
    displayName: 'Stade Rennais FC',
    logoUrl: 'soccer/stade_rennais_fc.webp',
  },
  'Le Havre AC': {
    displayName: 'Le Havre AC',
    logoUrl: 'soccer/le_havre_ac.webp',
  },
  'Paris Saint-Germain': {
    displayName: 'Paris Saint-Germain',
    logoUrl: 'soccer/paris_saint_germain.webp',
  },
  'Paris Saint Germain': {
    displayName: 'Paris Saint-Germain',
    logoUrl: 'soccer/paris_saint_germain.webp',
  },
  'Olympique Lyon': {
    displayName: 'Olympique Lyon',
    logoUrl: 'soccer/olympique_lyon.webp',
  },
  'AJ Auxerre': {
    displayName: 'AJ Auxerre',
    logoUrl: 'soccer/aj_auxerre.webp',
  },
  'FC Metz': {
    displayName: 'FC Metz',
    logoUrl: 'soccer/fc_metz.webp',
  },
  'Stade Brest 29': {
    displayName: 'Stade Brest 29',
    logoUrl: 'soccer/stade_brest_29.webp',
  },
  'Toulouse FC': {
    displayName: 'Toulouse FC',
    logoUrl: 'soccer/toulouse_fc.webp',
  },
  'FC Lorient': {
    displayName: 'FC Lorient',
    logoUrl: 'soccer/fc_lorient.webp',
  },
  'FC Nantes': {
    displayName: 'FC Nantes',
    logoUrl: 'soccer/fc_nantes.webp',
  },
  'Paris FC': {
    displayName: 'Paris FC',
    logoUrl: 'soccer/paris_fc.webp',
  },
  'Lille OSC': {
    displayName: 'Lille OSC',
    logoUrl: 'soccer/lille_osc.webp',
  },
  'St. Etienne': {
    displayName: 'St. Etienne',
    logoUrl: 'soccer/st_etienne.webp',
  },
  Tunisia: {
    displayName: 'Tunisia',
    logoUrl: 'flags/tunisia.webp',
  },
  Mali: {
    displayName: 'Mali',
    logoUrl: 'flags/mali.webp',
  },
  Tanzania: {
    displayName: 'Tanzania',
    logoUrl: 'flags/tanzania.webp',
  },
  Morocco: {
    displayName: 'Morocco',
    logoUrl: 'flags/morocco.webp',
  },
  Cameroon: {
    displayName: 'Cameroon',
    logoUrl: 'flags/cameroon.webp',
  },
  'South Africa': {
    displayName: 'South Africa',
    logoUrl: 'flags/south_africa.webp',
  },
  Benin: {
    displayName: 'Benin',
    logoUrl: 'flags/benin.webp',
  },
  Egypt: {
    displayName: 'Egypt',
    logoUrl: 'flags/egypt.webp',
  },
  Mozambique: {
    displayName: 'Mozambique',
    logoUrl: 'flags/mozambique.webp',
  },
  Nigeria: {
    displayName: 'Nigeria',
    logoUrl: 'flags/nigeria.webp',
  },
  'Congo DR': {
    displayName: 'Congo DR',
    logoUrl: 'flags/congo_dr.webp',
  },
  Algeria: {
    displayName: 'Algeria',
    logoUrl: 'flags/algeria.webp',
  },
  'Burkina Faso': {
    displayName: 'Burkina Faso',
    logoUrl: 'flags/burkina_faso.webp',
  },
  'Ivory Coast': {
    displayName: 'Ivory Coast',
    logoUrl: 'flags/ivory_coast.webp',
  },
  'Bodoe/Glimt': {
    displayName: 'Bodoe/Glimt',
    logoUrl: 'soccer/bodoe_glimt.webp',
  },
  'Ajax Amsterdam': {
    displayName: 'Ajax Amsterdam',
    logoUrl: 'soccer/ajax_amsterdam.webp',
  },
  'Olympiacos Piraeus': {
    displayName: 'Olympiacos Piraeus',
    logoUrl: 'soccer/olympiacos_piraeus.webp',
  },
  Olympiacos: {
    displayName: 'Olympiacos',
    logoUrl: 'soccer/olympiacos_piraeus.webp',
  },
  'FC Copenhagen': {
    displayName: 'FC Copenhagen',
    logoUrl: 'soccer/fc_copenhagen.webp',
  },
  'Sporting CP': {
    displayName: 'Sporting CP',
    logoUrl: 'soccer/sporting_cp.webp',
  },
  'Qarabag FK': {
    displayName: 'Qarabag FK',
    logoUrl: 'soccer/qarabag_fk.webp',
  },
  'Galatasaray Istanbul': {
    displayName: 'Galatasaray Istanbul',
    logoUrl: 'soccer/galatasaray_istanbul.webp',
  },
  'PSV Eindhoven': {
    displayName: 'PSV Eindhoven',
    logoUrl: 'soccer/psv_eindhoven.webp',
  },
  'SL Benfica': {
    displayName: 'SL Benfica',
    logoUrl: 'soccer/sl_benfica.webp',
  },
  'Slavia Prague': {
    displayName: 'Slavia Prague',
    logoUrl: 'soccer/slavia_prague.webp',
  },
  'Pafos FC': {
    displayName: 'Pafos FC',
    logoUrl: 'soccer/pafos_fc.webp',
  },
  'Union Saint-Gilloise': {
    displayName: 'Union Saint-Gilloise',
    logoUrl: 'soccer/union_saint_gilloise.webp',
  },
  'FC Kairat Almaty': {
    displayName: 'FC Kairat Almaty',
    logoUrl: 'soccer/fc_kairat_almaty.webp',
  },
  'Club Brugge': {
    displayName: 'Club Brugge',
    logoUrl: 'soccer/club_brugge.webp',
  },
  'Stoke City': {
    displayName: 'Stoke City',
    logoUrl: 'soccer/stoke_city.webp',
  },
  'Charlton Athletic': {
    displayName: 'Charlton Athletic',
    logoUrl: 'soccer/charlton_athletic.webp',
  },
  'Millwall FC': {
    displayName: 'Millwall FC',
    logoUrl: 'soccer/millwall_fc.webp',
  },
  'Sheffield Wednesday': {
    displayName: 'Sheffield Wednesday',
    logoUrl: 'soccer/sheffield_wednesday.webp',
  },
  'Swansea City': {
    displayName: 'Swansea City',
    logoUrl: 'soccer/swansea_city.webp',
  },
  'Derby County': {
    displayName: 'Derby County',
    logoUrl: 'soccer/derby_county.webp',
  },
  'Watford FC': {
    displayName: 'Watford FC',
    logoUrl: 'soccer/watford_fc.webp',
  },
  'Preston North End': {
    displayName: 'Preston North End',
    logoUrl: 'soccer/preston_north_end.webp',
  },
  'Blackburn Rovers': {
    displayName: 'Blackburn Rovers',
    logoUrl: 'soccer/blackburn_rovers.webp',
  },
  'Queens Park Rangers': {
    displayName: 'Queens Park Rangers',
    logoUrl: 'soccer/queens_park_rangers.webp',
  },
  'Sheffield United': {
    displayName: 'Sheffield United',
    logoUrl: 'soccer/sheffield_united.webp',
  },
  'Portsmouth FC': {
    displayName: 'Portsmouth FC',
    logoUrl: 'soccer/portsmouth_fc.webp',
  },
  'Middlesbrough FC': {
    displayName: 'Middlesbrough FC',
    logoUrl: 'soccer/middlesbrough_fc.webp',
  },
  'Coventry City': {
    displayName: 'Coventry City',
    logoUrl: 'soccer/coventry_city.webp',
  },
  Coventry: {
    displayName: 'Coventry',
    logoUrl: 'soccer/coventry_city.webp',
  },
  'Wrexham AFC': {
    displayName: 'Wrexham AFC',
    logoUrl: 'soccer/wrexham_afc.webp',
  },
  'Bristol City': {
    displayName: 'Bristol City',
    logoUrl: 'soccer/bristol_city.webp',
  },
  'Birmingham City': {
    displayName: 'Birmingham City',
    logoUrl: 'soccer/birmingham_city.webp',
  },
  'Hull City': {
    displayName: 'Hull City',
    logoUrl: 'soccer/hull_city.webp',
  },
  'Ipswich Town': {
    displayName: 'Ipswich Town',
    logoUrl: 'soccer/ipswich_town.webp',
  },
  'Oxford United': {
    displayName: 'Oxford United',
    logoUrl: 'soccer/oxford_united.webp',
  },
  'West Bromwich Albion': {
    displayName: 'West Bromwich Albion',
    logoUrl: 'soccer/west_bromwich_albion.webp',
  },
  'Leicester City': {
    displayName: 'Leicester City',
    logoUrl: 'soccer/leicester_city.webp',
  },
  'Norwich City': {
    displayName: 'Norwich City',
    logoUrl: 'soccer/norwich_city.webp',
  },
  'Southampton FC': {
    displayName: 'Southampton FC',
    logoUrl: 'soccer/southampton_fc.webp',
  },
  'CF Cruz Azul': {
    displayName: 'CF Cruz Azul',
    logoUrl: 'soccer/cf_cruz_azul.webp',
  },
  'Club Santos Laguna': {
    displayName: 'Club Santos Laguna',
    logoUrl: 'soccer/club_santos_laguna.webp',
  },
  'Club Necaxa': {
    displayName: 'Club Necaxa',
    logoUrl: 'soccer/club_necaxa.webp',
  },
  'CF Pachuca': {
    displayName: 'CF Pachuca',
    logoUrl: 'soccer/cf_pachuca.webp',
  },
  'Mazatlan FC': {
    displayName: 'Mazatlan FC',
    logoUrl: 'soccer/mazatlan_fc.webp',
  },
  'Atletico San Luis': {
    displayName: 'Atletico San Luis',
    logoUrl: 'soccer/atletico_san_luis.webp',
  },
  'Deportivo Toluca FC': {
    displayName: 'Deportivo Toluca FC',
    logoUrl: 'soccer/deportivo_toluca_fc.webp',
  },
  'Pumas UNAM': {
    displayName: 'Pumas UNAM',
    logoUrl: 'soccer/pumas_unam.webp',
  },
  'Tigres UANL': {
    displayName: 'Tigres UANL',
    logoUrl: 'soccer/tigres_uanl.webp',
  },
  'Club Puebla': {
    displayName: 'Club Puebla',
    logoUrl: 'soccer/club_puebla.webp',
  },
  'Queretaro FC': {
    displayName: 'Queretaro FC',
    logoUrl: 'soccer/queretaro_fc.webp',
  },
  'CF Monterrey': {
    displayName: 'CF Monterrey',
    logoUrl: 'soccer/cf_monterrey.webp',
  },
  'Club Tijuana de Caliente': {
    displayName: 'Club Tijuana de Caliente',
    logoUrl: 'soccer/club_tijuana_de_caliente.webp',
  },
  'Atlas FC': {
    displayName: 'Atlas FC',
    logoUrl: 'soccer/atlas_fc.webp',
  },
  'FC Juarez': {
    displayName: 'FC Juarez',
    logoUrl: 'soccer/fc_juarez.webp',
  },
  'CF America': {
    displayName: 'CF America',
    logoUrl: 'soccer/cf_america.webp',
  },
  'Club Leon': {
    displayName: 'Club Leon',
    logoUrl: 'soccer/club_leon.webp',
  },
  'CD Guadalajara': {
    displayName: 'CD Guadalajara',
    logoUrl: 'soccer/cd_guadalajara.webp',
  },
  'Orlando City SC': {
    displayName: 'Orlando City SC',
    logoUrl: 'soccer/orlando_city_sc.webp',
  },
  'Orlando City': {
    displayName: 'Orlando City',
    logoUrl: 'soccer/orlando_city_sc.webp',
  },
  'DC United': {
    displayName: 'DC United',
    logoUrl: 'soccer/dc_united.webp',
  },
  'Chicago Fire': {
    displayName: 'Chicago Fire',
    logoUrl: 'soccer/chicago_fire.webp',
  },
  'Columbus Crew': {
    displayName: 'Columbus Crew',
    logoUrl: 'soccer/columbus_crew.webp',
  },
  'Real Salt Lake': {
    displayName: 'Real Salt Lake',
    logoUrl: 'soccer/real_salt_lake.webp',
  },
  'Atlanta United FC': {
    displayName: 'Atlanta United FC',
    logoUrl: 'soccer/atlanta_united_fc.webp',
  },
  'Austin FC': {
    displayName: 'Austin FC',
    logoUrl: 'soccer/austin_fc.webp',
  },
  'Charlotte FC': {
    displayName: 'Charlotte FC',
    logoUrl: 'soccer/charlotte_fc.webp',
  },
  Charlotte: {
    displayName: 'Charlotte',
    logoUrl: 'soccer/charlotte_fc.webp',
  },
  'New England Revolution': {
    displayName: 'New England Revolution',
    logoUrl: 'soccer/new_england_revolution.webp',
  },
  'San Jose Earthquakes': {
    displayName: 'San Jose Earthquakes',
    logoUrl: 'soccer/san_jose_earthquakes.webp',
  },
  'Nashville SC': {
    displayName: 'Nashville SC',
    logoUrl: 'soccer/nashville_sc.webp',
  },
  'Seattle Sounders': {
    displayName: 'Seattle Sounders',
    logoUrl: 'soccer/seattle_sounders.webp',
  },
  'Saint Louis City SC': {
    displayName: 'Saint Louis City SC',
    logoUrl: 'soccer/saint_louis_city_sc.webp',
  },
  'Sporting Kansas City': {
    displayName: 'Sporting Kansas City',
    logoUrl: 'soccer/sporting_kansas_city.webp',
  },
  'Sporting Jax': {
    displayName: 'Sporting Jax',
    logoUrl: 'soccer/sporting_jax.webp',
  },
  'Los Angeles Galaxy': {
    displayName: 'Los Angeles Galaxy',
    logoUrl: 'soccer/los_angeles_galaxy.webp',
  },
  'Colorado Rapids': {
    displayName: 'Colorado Rapids',
    logoUrl: 'soccer/colorado_rapids.webp',
  },
  'Portland Timbers': {
    displayName: 'Portland Timbers',
    logoUrl: 'soccer/portland_timbers.webp',
  },
  'FC Dallas': {
    displayName: 'FC Dallas',
    logoUrl: 'soccer/fc_dallas.webp',
  },
  'CF Montreal': {
    displayName: 'CF Montreal',
    logoUrl: 'soccer/cf_montreal.webp',
  },
  'New York Red Bulls': {
    displayName: 'New York Red Bulls',
    logoUrl: 'soccer/new_york_red_bulls.webp',
  },
  'Toronto FC': {
    displayName: 'Toronto FC',
    logoUrl: 'soccer/toronto_fc.webp',
  },
  'Velez Sarsfield': {
    displayName: 'Velez Sarsfield',
    logoUrl: 'soccer/velez_sarsfield.webp',
  },
  Velez: {
    displayName: 'Velez',
    logoUrl: 'soccer/velez_sarsfield.webp',
  },
  'CA Tigre': {
    displayName: 'CA Tigre',
    logoUrl: 'soccer/ca_tigre.webp',
  },
  'Union de Santa Fe': {
    displayName: 'Union de Santa Fe',
    logoUrl: 'soccer/union_de_santa_fe.webp',
  },
  'CA Independiente Avellaneda': {
    displayName: 'CA Independiente Avellaneda',
    logoUrl: 'soccer/ca_independiente_avellaneda.webp',
  },
  'CA Platense': {
    displayName: 'CA Platense',
    logoUrl: 'soccer/ca_platense.webp',
  },
  "Newell's Old Boys": {
    displayName: "Newell's Old Boys",
    logoUrl: 'soccer/newells_old_boys.webp',
  },
  'Racing Club Avellaneda': {
    displayName: 'Racing Club Avellaneda',
    logoUrl: 'soccer/racing_club_avellaneda.webp',
  },
  'CA Sarmiento Junin': {
    displayName: 'CA Sarmiento Junin',
    logoUrl: 'soccer/ca_sarmiento_junin.webp',
  },
  'CA Rosario Central': {
    displayName: 'CA Rosario Central',
    logoUrl: 'soccer/ca_rosario_central.webp',
  },
  'Argentinos Juniors': {
    displayName: 'Argentinos Juniors',
    logoUrl: 'soccer/argentinos_juniors.webp',
  },
  'Gimnasia y Esgrima La Plata': {
    displayName: 'Gimnasia y Esgrima La Plata',
    logoUrl: 'soccer/gimnasia_y_esgrima_la_plata.webp',
  },
  'CA Banfield': {
    displayName: 'CA Banfield',
    logoUrl: 'soccer/ca_banfield.webp',
  },
  'CA San Lorenzo de Almagro': {
    displayName: 'CA San Lorenzo de Almagro',
    logoUrl: 'soccer/ca_san_lorenzo_de_almagro.webp',
  },
  'Boca Juniors': {
    displayName: 'Boca Juniors',
    logoUrl: 'soccer/boca_juniors.webp',
  },
  'CA Barracas Central': {
    displayName: 'CA Barracas Central',
    logoUrl: 'soccer/ca_barracas_central.webp',
  },
  'Independiente Rivadavia': {
    displayName: 'Independiente Rivadavia',
    logoUrl: 'soccer/independiente_rivadavia.webp',
  },
  'CA Aldosivi': {
    displayName: 'CA Aldosivi',
    logoUrl: 'soccer/ca_aldosivi.webp',
  },
  'Atletico Tucuman': {
    displayName: 'Atletico Tucuman',
    logoUrl: 'soccer/atletico_tucuman.webp',
  },
  'CA Central Cordoba SE': {
    displayName: 'CA Central Cordoba SE',
    logoUrl: 'soccer/ca_central_cordoba_se.webp',
  },
  'Defensa y Justicia': {
    displayName: 'Defensa y Justicia',
    logoUrl: 'soccer/defensa_y_justicia.webp',
  },
  'Gimnasia y Esgrima Mendoza': {
    displayName: 'Gimnasia y Esgrima Mendoza',
    logoUrl: 'soccer/gimnasia_y_esgrima_mendoza.webp',
  },
  'Deportivo Riestra AFBC': {
    displayName: 'Deportivo Riestra AFBC',
    logoUrl: 'soccer/deportivo_riestra_afbc.webp',
  },
  'Instituto AC Cordoba': {
    displayName: 'Instituto AC Cordoba',
    logoUrl: 'soccer/instituto_ac_cordoba.webp',
  },
  'CA Talleres de Cordoba': {
    displayName: 'CA Talleres de Cordoba',
    logoUrl: 'soccer/ca_talleres_de_cordoba.webp',
  },
  'CA Belgrano de Cordoba': {
    displayName: 'CA Belgrano de Cordoba',
    logoUrl: 'soccer/ca_belgrano_de_cordoba.webp',
  },
  'Estudiantes Rio Cuarto': {
    displayName: 'Estudiantes Rio Cuarto',
    logoUrl: 'soccer/estudiantes_rio_cuarto.webp',
  },
  'CA River Plate (ARG)': {
    displayName: 'CA River Plate (ARG)',
    logoUrl: 'soccer/ca_river_plate_arg.webp',
  },
  'CA Huracan': {
    displayName: 'CA Huracan',
    logoUrl: 'soccer/ca_huracan.webp',
  },
  'CA Lanus': {
    displayName: 'CA Lanus',
    logoUrl: 'soccer/ca_lanus.webp',
  },
  'Estudiantes de La Plata': {
    displayName: 'Estudiantes de La Plata',
    logoUrl: 'soccer/estudiantes_de_la_plata.webp',
  },
  'Angers SCO': {
    displayName: 'Angers SCO',
    logoUrl: 'soccer/angers_sco.webp',
  },
  'Racing Club de Lens': {
    displayName: 'Racing Club de Lens',
    logoUrl: 'soccer/rc_lens.webp',
  },
  'Kashima Antlers': {
    displayName: 'Kashima Antlers',
    logoUrl: 'soccer/kashima_antlers.webp',
  },
  'Yokohama F Marinos': {
    displayName: 'Yokohama F Marinos',
    logoUrl: 'soccer/yokohama_f_marinos.webp',
  },
  'Urawa Red Diamonds': {
    displayName: 'Urawa Red Diamonds',
    logoUrl: 'soccer/urawa_red_diamonds.webp',
  },
  'Gamba Osaka': {
    displayName: 'Gamba Osaka',
    logoUrl: 'soccer/gamba_osaka.webp',
  },
  'Excelsior Rotterdam': {
    displayName: 'Excelsior Rotterdam',
    logoUrl: 'soccer/excelsior_rotterdam.webp',
  },
  'Cambuur Leewarden': {
    displayName: 'Cambuur Leewarden',
    logoUrl: 'soccer/cambuur_leewarden.webp',
  },
  'Hertha BSC': {
    displayName: 'Hertha BSC',
    logoUrl: 'soccer/hertha_bsc.webp',
  },
  'VfL Bochum': {
    displayName: 'VfL Bochum',
    logoUrl: 'soccer/vfl_bochum.webp',
  },
  'KV Kortrijk': {
    displayName: 'KV Kortrijk',
    logoUrl: 'soccer/kv_kortrijk.webp',
  },
  'FC Famalicao': {
    displayName: 'FC Famalicao',
    logoUrl: 'soccer/fc_famalicao.webp',
  },
  'Estoril Praia': {
    displayName: 'Estoril Praia',
    logoUrl: 'soccer/estoril_praia.webp',
  },
  'EA Guingamp': {
    displayName: 'EA Guingamp',
    logoUrl: 'soccer/ea_guingamp.webp',
  },
  'Stade Reims': {
    displayName: 'Stade Reims',
    logoUrl: 'soccer/stade_reims.webp',
  },
  'Clermont Foot 63': {
    displayName: 'Clermont Foot 63',
    logoUrl: 'soccer/clermont_foot_63.webp',
  },
  Dijon: {
    displayName: 'Dijon',
    logoUrl: 'soccer/dijon.webp',
  },
  'Montpellier HSC': {
    displayName: 'Montpellier HSC',
    logoUrl: 'soccer/montpellier_hsc.webp',
  },
  'Rodez Aveyron Football': {
    displayName: 'Rodez Aveyron Football',
    logoUrl: 'soccer/rodez_aveyron_football.webp',
  },
  'Nancy-Lorraine': {
    displayName: 'Nancy-Lorraine',
    logoUrl: 'soccer/nancy_lorraine.webp',
  },
  'US Boulogne': {
    displayName: 'US Boulogne',
    logoUrl: 'soccer/us_boulogne.webp',
  },
  'Red Star FC': {
    displayName: 'Red Star FC',
    logoUrl: 'soccer/red_star_fc.webp',
  },
  'AS Saint-Etienne': {
    displayName: 'AS Saint-Etienne',
    logoUrl: 'soccer/st_etienne.webp',
  },
  Sochaux: {
    displayName: 'Sochaux',
    logoUrl: 'soccer/sochaux.webp',
  },
  'Grenoble Foot': {
    displayName: 'Grenoble Foot',
    logoUrl: 'soccer/grenoble_foot.webp',
  },
  Annecy: {
    displayName: 'Annecy',
    logoUrl: 'soccer/annecy.webp',
  },
  'Pau FC': {
    displayName: 'Pau FC',
    logoUrl: 'soccer/pau_fc.webp',
  },
  // WC Qualifiers Europe — national teams (flags on CDN), ordered by draw groups A–L
  // Group A
  Germany: {
    displayName: 'Germany',
    logoUrl: 'flags/germany.webp',
  },
  Slovakia: {
    displayName: 'Slovakia',
    logoUrl: 'flags/slovakia.webp',
  },
  'Northern Ireland': {
    displayName: 'Northern Ireland',
    logoUrl: 'flags/northern_ireland.webp',
  },
  Luxembourg: {
    displayName: 'Luxembourg',
    logoUrl: 'flags/luxembourg.webp',
  },
  // Group B
  Switzerland: {
    displayName: 'Switzerland',
    logoUrl: 'flags/switzerland.webp',
  },
  Sweden: {
    displayName: 'Sweden',
    logoUrl: 'flags/sweden.webp',
  },
  Slovenia: {
    displayName: 'Slovenia',
    logoUrl: 'flags/slovenia.webp',
  },
  Kosovo: {
    displayName: 'Kosovo',
    logoUrl: 'flags/kosovo.webp',
  },
  // Group C
  Denmark: {
    displayName: 'Denmark',
    logoUrl: 'flags/denmark.webp',
  },
  Greece: {
    displayName: 'Greece',
    logoUrl: 'flags/greece.webp',
  },
  Scotland: {
    displayName: 'Scotland',
    logoUrl: 'flags/scotland.webp',
  },
  Belarus: {
    displayName: 'Belarus',
    logoUrl: 'flags/belarus.webp',
  },
  // Group D
  France: {
    displayName: 'France',
    logoUrl: 'flags/france.webp',
  },
  Ukraine: {
    displayName: 'Ukraine',
    logoUrl: 'flags/ukraine.webp',
  },
  Iceland: {
    displayName: 'Iceland',
    logoUrl: 'flags/iceland.webp',
  },
  Azerbaijan: {
    displayName: 'Azerbaijan',
    logoUrl: 'flags/azerbaijan.webp',
  },
  // Group E
  Spain: {
    displayName: 'Spain',
    logoUrl: 'flags/spain.webp',
  },
  Türkiye: {
    displayName: 'Türkiye',
    logoUrl: 'flags/turkey.webp',
  },
  Georgia: {
    displayName: 'Georgia',
    logoUrl: 'flags/georgia.webp',
  },
  Bulgaria: {
    displayName: 'Bulgaria',
    logoUrl: 'flags/bulgaria.webp',
  },
  // Group F
  Portugal: {
    displayName: 'Portugal',
    logoUrl: 'flags/portugal.webp',
  },
  Hungary: {
    displayName: 'Hungary',
    logoUrl: 'flags/hungary.webp',
  },
  Armenia: {
    displayName: 'Armenia',
    logoUrl: 'flags/armenia.webp',
  },
  // Group G
  Netherlands: {
    displayName: 'Netherlands',
    logoUrl: 'flags/netherlands.webp',
  },
  Poland: {
    displayName: 'Poland',
    logoUrl: 'flags/poland.webp',
  },
  Finland: {
    displayName: 'Finland',
    logoUrl: 'flags/finland.webp',
  },
  Lithuania: {
    displayName: 'Lithuania',
    logoUrl: 'flags/lithuania.webp',
  },
  Malta: {
    displayName: 'Malta',
    logoUrl: 'flags/malta.webp',
  },
  // Group H
  Austria: {
    displayName: 'Austria',
    logoUrl: 'flags/austria.webp',
  },
  Romania: {
    displayName: 'Romania',
    logoUrl: 'flags/romania.webp',
  },
  'Bosnia and Herzegovina': {
    displayName: 'Bosnia and Herzegovina',
    logoUrl: 'flags/bosnia_and_herzegovina.webp',
  },
  Cyprus: {
    displayName: 'Cyprus',
    logoUrl: 'flags/cyprus.webp',
  },
  'San Marino': {
    displayName: 'San Marino',
    logoUrl: 'flags/san_marino.webp',
  },
  // Group I
  Italy: {
    displayName: 'Italy',
    logoUrl: 'flags/italy.webp',
  },
  Norway: {
    displayName: 'Norway',
    logoUrl: 'flags/norway.webp',
  },
  Israel: {
    displayName: 'Israel',
    logoUrl: 'flags/israel.webp',
  },
  Estonia: {
    displayName: 'Estonia',
    logoUrl: 'flags/estonia.webp',
  },
  Moldova: {
    displayName: 'Moldova',
    logoUrl: 'flags/moldova.webp',
  },
  // Group J
  Belgium: {
    displayName: 'Belgium',
    logoUrl: 'flags/belgium.webp',
  },
  Wales: {
    displayName: 'Wales',
    logoUrl: 'flags/wales.webp',
  },
  'North Macedonia': {
    displayName: 'North Macedonia',
    logoUrl: 'flags/north_macedonia.webp',
  },
  Kazakhstan: {
    displayName: 'Kazakhstan',
    logoUrl: 'flags/kazakhstan.webp',
  },
  Liechtenstein: {
    displayName: 'Liechtenstein',
    logoUrl: 'flags/liechtenstein.webp',
  },
  // Group K
  England: {
    displayName: 'England',
    logoUrl: 'flags/england.webp',
  },
  Serbia: {
    displayName: 'Serbia',
    logoUrl: 'flags/serbia.webp',
  },
  Albania: {
    displayName: 'Albania',
    logoUrl: 'flags/albania.webp',
  },
  Latvia: {
    displayName: 'Latvia',
    logoUrl: 'flags/latvia.webp',
  },
  Andorra: {
    displayName: 'Andorra',
    logoUrl: 'flags/andorra.webp',
  },
  // Group L
  Croatia: {
    displayName: 'Croatia',
    logoUrl: 'flags/croatia.webp',
  },
  Czechia: {
    displayName: 'Czechia',
    logoUrl: 'flags/czech_republic.webp',
  },
  Montenegro: {
    displayName: 'Montenegro',
    logoUrl: 'flags/montenegro.webp',
  },
  'Faroe Islands': {
    displayName: 'Faroe Islands',
    logoUrl: 'flags/faroe_islands.webp',
  },
  Gibraltar: {
    displayName: 'Gibraltar',
    logoUrl: 'flags/gibraltar.webp',
  },
  // Alternate spellings / additional national teams
  Ireland: {
    displayName: 'Ireland',
    logoUrl: 'flags/ireland.webp',
  },
  Turkiye: {
    displayName: 'Turkiye',
    logoUrl: 'flags/turkey.webp',
  },
  Suriname: {
    displayName: 'Suriname',
    logoUrl: 'flags/suriname.webp',
  },
  Bolivia: {
    displayName: 'Bolivia',
    logoUrl: 'flags/bolivia.webp',
  },
  Jamaica: {
    displayName: 'Jamaica',
    logoUrl: 'flags/jamaica.webp',
  },
  'New Caledonia': {
    displayName: 'New Caledonia',
    logoUrl: 'flags/new_caledonia.webp',
  },
  Ghana: {
    displayName: 'Ghana',
    logoUrl: 'flags/ghana.webp',
  },
  Panama: {
    displayName: 'Panama',
    logoUrl: 'flags/panama.webp',
  },
  Paraguay: {
    displayName: 'Paraguay',
    logoUrl: 'flags/paraguay.webp',
  },
  Uruguay: {
    displayName: 'Uruguay',
    logoUrl: 'flags/uruguay.webp',
  },
  Ecuador: {
    displayName: 'Ecuador',
    logoUrl: 'flags/ecuador.webp',
  },
  'South Korea': {
    displayName: 'South Korea',
    logoUrl: 'flags/south_korea.webp',
  },
  Peru: {
    displayName: 'Peru',
    logoUrl: 'flags/peru.webp',
  },
  Senegal: {
    displayName: 'Senegal',
    logoUrl: 'flags/senegal.webp',
  },
  Canada: {
    displayName: 'Canada',
    logoUrl: 'flags/canada.webp',
  },
  Japan: {
    displayName: 'Japan',
    logoUrl: 'flags/japan.webp',
  },
  USA: {
    displayName: 'USA',
    logoUrl: 'flags/united_states.webp',
  },
  Haiti: {
    displayName: 'Haiti',
    logoUrl: 'flags/haiti.webp',
  },
  Mexico: {
    displayName: 'Mexico',
    logoUrl: 'flags/mexico.webp',
  },
  Colombia: {
    displayName: 'Colombia',
    logoUrl: 'flags/colombia.webp',
  },
  'Saudi Arabia': {
    displayName: 'Saudi Arabia',
    logoUrl: 'flags/saudi_arabia.webp',
  },
  Russia: {
    displayName: 'Russia',
    logoUrl: 'flags/russia.webp',
  },
  Honduras: {
    displayName: 'Honduras',
    logoUrl: 'flags/honduras.webp',
  },
  Zambia: {
    displayName: 'Zambia',
    logoUrl: 'flags/zambia.webp',
  },
  Argentina: {
    displayName: 'Argentina',
    logoUrl: 'flags/argentina.webp',
  },
  Brazil: {
    displayName: 'Brazil',
    logoUrl: 'flags/brazil.webp',
  },
  'Fluminense FC RJ': {
    displayName: 'Fluminense FC RJ',
    logoUrl: 'soccer/fluminense_fc_rj.webp',
  },
  'Deportivo La Guaira': {
    displayName: 'Deportivo La Guaira',
    logoUrl: 'soccer/deportivo_la_guaira.webp',
  },
  Bolivar: {
    displayName: 'Bolivar',
    logoUrl: 'soccer/bolivar.webp',
  },
  'Ind. Rivadavia': {
    displayName: 'Ind. Rivadavia',
    logoUrl: 'soccer/independiente_rivadavia.webp',
  },
  'LDU Quito': {
    displayName: 'LDU Quito',
    logoUrl: 'soccer/ldu_quito.webp',
  },
  'Always Ready': {
    displayName: 'Always Ready',
    logoUrl: 'soccer/always_ready.webp',
  },
  'Cruzeiro EC MG': {
    displayName: 'Cruzeiro EC MG',
    logoUrl: 'soccer/cruzeiro_ec_mg.webp',
  },
  'Barcelona SC': {
    displayName: 'Barcelona SC',
    logoUrl: 'soccer/barcelona_sc.webp',
  },
  'U Catolica de Chile': {
    displayName: 'U Catolica de Chile',
    logoUrl: 'soccer/u_catolica_de_chile.webp',
  },
  'Universitario de Deportes': {
    displayName: 'Universitario de Deportes',
    logoUrl: 'soccer/universitario_de_deportes.webp',
  },
  'Deportes Tolima': {
    displayName: 'Deportes Tolima',
    logoUrl: 'soccer/deportes_tolima.webp',
  },
  'FC Porto': {
    displayName: 'FC Porto',
    logoUrl: 'soccer/fc_porto.webp',
  },
  'Sporting Lisbon': {
    displayName: 'Sporting Lisbon',
    logoUrl: 'soccer/sporting_cp.webp',
  },
  'CSD Independiente Del Valle': {
    displayName: 'CSD Independiente Del Valle',
    logoUrl: 'soccer/csd_independiente_del_valle.webp',
  },
  'Libertad Asuncion': {
    displayName: 'Libertad Asuncion',
    logoUrl: 'soccer/libertad_asuncion.webp',
  },
  UCV: {
    displayName: 'UCV',
    logoUrl: 'soccer/ucv.webp',
  },
  'SC Corinthians SP': {
    displayName: 'SC Corinthians SP',
    logoUrl: 'soccer/sc_corinthians_sp.webp',
  },
  Penarol: {
    displayName: 'Penarol',
    logoUrl: 'soccer/penarol.webp',
  },
  'Santa Fe Bogota': {
    displayName: 'Santa Fe Bogota',
    logoUrl: 'soccer/santa_fe_bogota.webp',
  },
  'Mirassol FC SP': {
    displayName: 'Mirassol FC SP',
    logoUrl: 'soccer/mirassol_fc_sp.webp',
  },
  'Independiente Medellin': {
    displayName: 'Independiente Medellin',
    logoUrl: 'soccer/independiente_medellin.webp',
  },
  'CR Flamengo RJ': {
    displayName: 'CR Flamengo RJ',
    logoUrl: 'soccer/cr_flamengo_rj.webp',
  },
  'Cusco FC': {
    displayName: 'Cusco FC',
    logoUrl: 'soccer/cusco_fc.webp',
  },
  Junior: {
    displayName: 'Junior',
    logoUrl: 'soccer/junior.webp',
  },
  'Cerro Porteno': {
    displayName: 'Cerro Porteno',
    logoUrl: 'soccer/cerro_porteno.webp',
  },
  'Club Nacional': {
    displayName: 'Club Nacional',
    logoUrl: 'soccer/club_nacional.webp',
  },
  Coquimbo: {
    displayName: 'Coquimbo',
    logoUrl: 'soccer/coquimbo.webp',
  },
  'Bosnia & Herzegovina': {
    displayName: 'Bosnia & Herzegovina',
    logoUrl: 'flags/bosnia_and_herzegovina.webp',
  },
  Qatar: {
    displayName: 'Qatar',
    logoUrl: 'flags/qatar.webp',
  },
  Australia: {
    displayName: 'Australia',
    logoUrl: 'flags/australia.webp',
  },
  Curacao: {
    displayName: 'Curacao',
    logoUrl: 'flags/curacao.webp',
  },
  'Cape Verde': {
    displayName: 'Cape Verde',
    logoUrl: 'flags/cape_verde.webp',
  },
  'New Zealand': {
    displayName: 'New Zealand',
    logoUrl: 'flags/new_zealand.webp',
  },
  'IR Iran': {
    displayName: 'Iran',
    logoUrl: 'flags/iran.webp',
  },
  Iraq: {
    displayName: 'Iraq',
    logoUrl: 'flags/iraq.webp',
  },
  Jordan: {
    displayName: 'Jordan',
    logoUrl: 'flags/jordan.webp',
  },
  Uzbekistan: {
    displayName: 'Uzbekistan',
    logoUrl: 'flags/uzbekistan.webp',
  },
  'Sporting Cristal': {
    displayName: 'Sporting Cristal',
    logoUrl: 'soccer/sporting_cristal.webp',
  },
  'SE Palmeiras SP': {
    displayName: 'SE Palmeiras SP',
    logoUrl: 'soccer/se_palmeiras_sp.webp',
  },
  'Granada CF': {
    displayName: 'Granada CF',
    logoUrl: 'soccer/granada_cf.webp',
  },
  'Albacete Balompie': {
    displayName: 'Albacete Balompie',
    logoUrl: 'soccer/albacete_balompie.webp',
  },
  'SD Huesca': {
    displayName: 'SD Huesca',
    logoUrl: 'soccer/sd_huesca.webp',
  },
  'SD Eibar': {
    displayName: 'SD Eibar',
    logoUrl: 'soccer/sd_eibar.webp',
  },
  'Malaga CF': {
    displayName: 'Malaga CF',
    logoUrl: 'soccer/malaga_cf.webp',
  },
  'UD Almeria': {
    displayName: 'UD Almeria',
    logoUrl: 'soccer/ud_almeria.webp',
  },
  'CD Mirandes': {
    displayName: 'CD Mirandes',
    logoUrl: 'soccer/cd_mirandes.webp',
  },
  'RC Deportivo La Coruna': {
    displayName: 'RC Deportivo La Coruna',
    logoUrl: 'soccer/rc_deportivo_la_coruna.webp',
  },
  'Deportivo Coruna': {
    displayName: 'Deportivo Coruna',
    logoUrl: 'soccer/rc_deportivo_la_coruna.webp',
  },
  'Real Sociedad San Sebastian B': {
    displayName: 'Real Sociedad San Sebastian B',
    logoUrl: 'soccer/real_sociedad_san_sebastian_b.webp',
  },
  'Sporting Gijon': {
    displayName: 'Sporting Gijon',
    logoUrl: 'soccer/sporting_gijon.webp',
  },
  Ceuta: {
    displayName: 'Ceuta',
    logoUrl: 'soccer/ceuta.webp',
  },
  'FC Andorra': {
    displayName: 'FC Andorra',
    logoUrl: 'soccer/fc_andorra.webp',
  },
  'Burgos CF': {
    displayName: 'Burgos CF',
    logoUrl: 'soccer/burgos_cf.webp',
  },
  'Cultural Leonesa': {
    displayName: 'Cultural Leonesa',
    logoUrl: 'soccer/cultural_leonesa.webp',
  },
  'CD Castellon': {
    displayName: 'CD Castellon',
    logoUrl: 'soccer/cd_castellon.webp',
  },
  'Real Valladolid': {
    displayName: 'Real Valladolid',
    logoUrl: 'soccer/real_valladolid.webp',
  },
  'Cordoba CF': {
    displayName: 'Cordoba CF',
    logoUrl: 'soccer/cordoba_cf.webp',
  },
  'CD Leganes': {
    displayName: 'CD Leganes',
    logoUrl: 'soccer/cd_leganes.webp',
  },
  'Cadiz CF': {
    displayName: 'Cadiz CF',
    logoUrl: 'soccer/cadiz_cf.webp',
  },
  'Racing Santander': {
    displayName: 'Racing Santander',
    logoUrl: 'soccer/racing_santander.webp',
  },
  'Real Zaragoza': {
    displayName: 'Real Zaragoza',
    logoUrl: 'soccer/real_zaragoza.webp',
  },
  'UD Las Palmas': {
    displayName: 'UD Las Palmas',
    logoUrl: 'soccer/ud_las_palmas.webp',
  },
  'Stade Lavallois MFC': {
    displayName: 'Stade Lavallois MFC',
    logoUrl: 'soccer/stade_lavallois_mfc.webp',
  },
  'USL Dunkerque': {
    displayName: 'USL Dunkerque',
    logoUrl: 'soccer/usl_dunkerque.webp',
  },
  'Houston Dynamo': {
    displayName: 'Houston Dynamo',
    logoUrl: 'soccer/houston_dynamo.webp',
  },
  'Pittsburgh Riverhounds': {
    displayName: 'Pittsburgh Riverhounds',
    logoUrl: 'soccer/pittsburgh_riverhounds.webp',
  },
  Venezuela: {
    displayName: 'Venezuela',
    logoUrl: 'flags/venezuela.webp',
  },
  Guatemala: {
    displayName: 'Guatemala',
    logoUrl: 'flags/guatemala.webp',
  },
  'Trinidad and Tobago': {
    displayName: 'Trinidad and Tobago',
    logoUrl: 'flags/trinidad-and-tobago.webp',
  },
  'Costa Rica': {
    displayName: 'Costa Rica',
    logoUrl: 'flags/costa-rica.webp',
  },
  'Yunnan Yukun': {
    displayName: 'Yunnan Yukun',
    logoUrl: 'soccer/yunnan_yukun.webp',
  },
  'Shandong Taishan FC': {
    displayName: 'Shandong Taishan FC',
    logoUrl: 'soccer/shandong_taishan_fc.webp',
  },
  'Drogheda United FC': {
    displayName: 'Drogheda United FC',
    logoUrl: 'soccer/drogheda_united_fc.webp',
  },
  'Dundalk FC': {
    displayName: 'Dundalk FC',
    logoUrl: 'soccer/dundalk_fc.webp',
  },
  'Saint Patrick´s Athletic FC': {
    displayName: 'Saint Patrick´s Athletic FC',
    logoUrl: 'soccer/saint_patricks_athletic_fc.webp',
  },
  'Waterford FC': {
    displayName: 'Waterford FC',
    logoUrl: 'soccer/waterford_fc.webp',
  },
  'CD Universidad Catolica': {
    displayName: 'CD Universidad Catolica',
    logoUrl: 'soccer/cd_universidad_catolica.webp',
  },
  'Leones del Norte': {
    displayName: 'Leones del Norte',
    logoUrl: 'soccer/leones_del_norte.webp',
  },
  'CSD Macara': {
    displayName: 'CSD Macara',
    logoUrl: 'soccer/csd_macara.webp',
  },
  'Tecnico Universitario': {
    displayName: 'Tecnico Universitario',
    logoUrl: 'soccer/tecnico_universitario.webp',
  },
  Henan: {
    displayName: 'Henan',
    logoUrl: 'soccer/henan.webp',
  },
  'Wuhan Three Towns FC': {
    displayName: 'Wuhan Three Towns FC',
    logoUrl: 'soccer/wuhan_three_towns_fc.webp',
  },
  'Qingdao Hainiu FC': {
    displayName: 'Qingdao Hainiu FC',
    logoUrl: 'soccer/qingdao_hainiu_fc.webp',
  },
  'Zhejiang FC': {
    displayName: 'Zhejiang FC',
    logoUrl: 'soccer/zhejiang_fc.webp',
  },
  'Beijing Guoan': {
    displayName: 'Beijing Guoan',
    logoUrl: 'soccer/beijing_guoan.webp',
  },
  'Shanghai Shenhua FC': {
    displayName: 'Shanghai Shenhua FC',
    logoUrl: 'soccer/shanghai_shenhua_fc.webp',
  },
  'Qingdao West Coast FC': {
    displayName: 'Qingdao West Coast FC',
    logoUrl: 'soccer/qingdao_west_coast_fc.webp',
  },
  'Shenzhen Peng City': {
    displayName: 'Shenzhen Peng City',
    logoUrl: 'soccer/shenzhen_peng_city.webp',
  },
  'Lillestroem SK': {
    displayName: 'Lillestroem SK',
    logoUrl: 'soccer/lillestroem_sk.webp',
  },
  'Fredrikstad FK': {
    displayName: 'Fredrikstad FK',
    logoUrl: 'soccer/fredrikstad_fk.webp',
  },
  'Chongqing Tonglianglong FC': {
    displayName: 'Chongqing Tonglianglong FC',
    logoUrl: 'soccer/chongqing_tonglianglong_fc.webp',
  },
  'Chengdu Rongcheng': {
    displayName: 'Chengdu Rongcheng',
    logoUrl: 'soccer/chengdu_rongcheng.webp',
  },
  'Molde FK': {
    displayName: 'Molde FK',
    logoUrl: 'soccer/molde_fk.webp',
  },
  Aalesund: {
    displayName: 'Aalesund',
    logoUrl: 'soccer/aalesund.webp',
  },
  'Sligo Rovers FC': {
    displayName: 'Sligo Rovers FC',
    logoUrl: 'soccer/sligo_rovers_fc.webp',
  },
  'Galway United FC': {
    displayName: 'Galway United FC',
    logoUrl: 'soccer/galway_united_fc.webp',
  },
  'Vaalerenga IF': {
    displayName: 'Vaalerenga IF',
    logoUrl: 'soccer/vaalerenga_if.webp',
  },
  'Tromsoe IL': {
    displayName: 'Tromsoe IL',
    logoUrl: 'soccer/tromsoe_il.webp',
  },
  'Orense SC': {
    displayName: 'Orense SC',
    logoUrl: 'soccer/orense_sc.webp',
  },
  Manta: {
    displayName: 'Manta',
    logoUrl: 'soccer/manta.webp',
  },
  'Mushuc Runa SC': {
    displayName: 'Mushuc Runa SC',
    logoUrl: 'soccer/mushuc_runa_sc.webp',
  },
  Delfin: {
    displayName: 'Delfin',
    logoUrl: 'soccer/delfin.webp',
  },
  'Guayaquil City FC': {
    displayName: 'Guayaquil City FC',
    logoUrl: 'soccer/guayaquil_city_fc.webp',
  },
  'Liaoning Tieren FC': {
    displayName: 'Liaoning Tieren FC',
    logoUrl: 'soccer/liaoning_tieren_fc.webp',
  },
  'Tianjin Jinmen Tiger': {
    displayName: 'Tianjin Jinmen Tiger',
    logoUrl: 'soccer/tianjin_jinmen_tiger.webp',
  },
  'Dalian Yingbo FC': {
    displayName: 'Dalian Yingbo FC',
    logoUrl: 'soccer/dalian_yingbo_fc.webp',
  },
  'Shanghai Port FC': {
    displayName: 'Shanghai Port FC',
    logoUrl: 'soccer/shanghai_port_fc.webp',
  },
  'KFUM Oslo': {
    displayName: 'KFUM Oslo',
    logoUrl: 'soccer/kfum_oslo.webp',
  },
  'Kristiansund BK': {
    displayName: 'Kristiansund BK',
    logoUrl: 'soccer/kristiansund_bk.webp',
  },
  'Rosenborg BK': {
    displayName: 'Rosenborg BK',
    logoUrl: 'soccer/rosenborg_bk.webp',
  },
  'IK Start': {
    displayName: 'IK Start',
    logoUrl: 'soccer/ik_start.webp',
  },
  'SK Brann': {
    displayName: 'SK Brann',
    logoUrl: 'soccer/sk_brann.webp',
  },
  HamKam: {
    displayName: 'HamKam',
    logoUrl: 'soccer/hamkam.webp',
  },
  'Sandefjord Fotball': {
    displayName: 'Sandefjord Fotball',
    logoUrl: 'soccer/sandefjord_fotball.webp',
  },
  'Viking FK': {
    displayName: 'Viking FK',
    logoUrl: 'soccer/viking_fk.webp',
  },
  'Sarpsborg 08': {
    displayName: 'Sarpsborg 08',
    logoUrl: 'soccer/sarpsborg_08.webp',
  },
  Aucas: {
    displayName: 'Aucas',
    logoUrl: 'soccer/aucas.webp',
  },
  'CD Cuenca': {
    displayName: 'CD Cuenca',
    logoUrl: 'soccer/cd_cuenca.webp',
  },
  Emelec: {
    displayName: 'Emelec',
    logoUrl: 'soccer/emelec.webp',
  },
  Vardar: {
    displayName: 'Vardar',
    logoUrl: 'soccer/vardar.webp',
  },
  KuPS: {
    displayName: 'KuPS',
    logoUrl: 'soccer/kups.webp',
  },
  Flora: {
    displayName: 'Flora',
    logoUrl: 'soccer/flora.webp',
  },
  'Iberia 1999': {
    displayName: 'Iberia 1999',
    logoUrl: 'soccer/iberia_1999.webp',
  },
  'Lincoln Red Imps': {
    displayName: 'Lincoln Red Imps',
    logoUrl: 'soccer/lincoln_red_imps.webp',
  },
  "Inter Club d'Escaldes": {
    displayName: "Inter Club d'Escaldes",
    logoUrl: 'soccer/inter_club_descaldes.webp',
  },
  'Ararat-Armenia': {
    displayName: 'Ararat-Armenia',
    logoUrl: 'soccer/ararat_armenia.webp',
  },
  Riga: {
    displayName: 'Riga',
    logoUrl: 'soccer/riga.webp',
  },
  'Vikingur Reykjavik': {
    displayName: 'Vikingur Reykjavik',
    logoUrl: 'soccer/vikingur_reykjavik.webp',
  },
  Vikingur: {
    displayName: 'Vikingur',
    logoUrl: 'soccer/vikingur_reykjavik.webp',
  },
  Gyor: {
    displayName: 'Gyor',
    logoUrl: 'soccer/gyor.webp',
  },
  'Borac Banja Luka': {
    displayName: 'Borac Banja Luka',
    logoUrl: 'soccer/borac_banja_luka.webp',
  },
  'Levski Sofia': {
    displayName: 'Levski Sofia',
    logoUrl: 'soccer/levski_sofia.webp',
  },
  'Sabah Baku': {
    displayName: 'Sabah Baku',
    logoUrl: 'soccer/sabah_baku.webp',
  },
  'The New Saints FC': {
    displayName: 'The New Saints FC',
    logoUrl: 'soccer/the_new_saints_fc.webp',
  },
  'Kauno Zalgiris': {
    displayName: 'Kauno Zalgiris',
    logoUrl: 'soccer/kauno_zalgiris.webp',
  },
  Zalgiris: {
    displayName: 'Zalgiris',
    logoUrl: 'soccer/kauno_zalgiris.webp',
  },
  Drita: {
    displayName: 'Drita',
    logoUrl: 'soccer/drita.webp',
  },
  Floriana: {
    displayName: 'Floriana',
    logoUrl: 'soccer/floriana.webp',
  },
  'Shamrock Rovers': {
    displayName: 'Shamrock Rovers',
    logoUrl: 'soccer/shamrock_rovers.webp',
  },
  'Tre Fiori': {
    displayName: 'Tre Fiori',
    logoUrl: 'soccer/tre_fiori.webp',
  },
  Larne: {
    displayName: 'Larne',
    logoUrl: 'soccer/larne.webp',
  },
  'UNA Strassen': {
    displayName: 'UNA Strassen',
    logoUrl: 'soccer/una_strassen.webp',
  },
  'La Fiorita': {
    displayName: 'La Fiorita',
    logoUrl: 'soccer/la_fiorita.webp',
  },
  'Vllaznia Shkoder': {
    displayName: 'Vllaznia Shkoder',
    logoUrl: 'soccer/vllaznia_shkoder.webp',
  },
  Malisheva: {
    displayName: 'Malisheva',
    logoUrl: 'soccer/malisheva.webp',
  },
  'ML Vitebsk': {
    displayName: 'ML Vitebsk',
    logoUrl: 'soccer/ml_vitebsk.webp',
  },
  'Univ. Craiova': {
    displayName: 'Univ. Craiova',
    logoUrl: 'soccer/univ_craiova.webp',
  },
  Bissen: {
    displayName: 'Bissen',
    logoUrl: 'soccer/bissen.webp',
  },
  Liepaja: {
    displayName: 'Liepaja',
    logoUrl: 'soccer/liepaja.webp',
  },
  Decic: {
    displayName: 'Decic',
    logoUrl: 'soccer/decic.webp',
  },
  Petrocub: {
    displayName: 'Petrocub',
    logoUrl: 'soccer/petrocub.webp',
  },
  'Egnatia Rrogozhine': {
    displayName: 'Egnatia Rrogozhine',
    logoUrl: 'soccer/egnatia_rrogozhine.webp',
  },
  Sutjeska: {
    displayName: 'Sutjeska',
    logoUrl: 'soccer/sutjeska.webp',
  },
  Alashkert: {
    displayName: 'Alashkert',
    logoUrl: 'soccer/alashkert.webp',
  },
  'Yelimay Semey': {
    displayName: 'Yelimay Semey',
    logoUrl: 'soccer/yelimay_semey.webp',
  },
  Dinamo: {
    displayName: 'Dinamo',
    logoUrl: 'soccer/dinamo.webp',
  },
  Astana: {
    displayName: 'Astana',
    logoUrl: 'soccer/astana.webp',
  },
  Sarajevo: {
    displayName: 'Sarajevo',
    logoUrl: 'soccer/sarajevo.webp',
  },
  'Inter Turku': {
    displayName: 'Inter Turku',
    logoUrl: 'soccer/inter_turku.webp',
  },
  'Bohemians Dublin FC': {
    displayName: 'Bohemians Dublin FC',
    logoUrl: 'soccer/bohemians_dublin_fc.webp',
  },
  "St Joseph's": {
    displayName: "St Joseph's",
    logoUrl: 'soccer/st_josephs.webp',
  },
  'Hegelmann Litauen': {
    displayName: 'Hegelmann Litauen',
    logoUrl: 'soccer/hegelmann_litauen.webp',
  },
  Paide: {
    displayName: 'Paide',
    logoUrl: 'soccer/paide.webp',
  },
  'Differdange 03': {
    displayName: 'Differdange 03',
    logoUrl: 'soccer/differdange_03.webp',
  },
  Ilves: {
    displayName: 'Ilves',
    logoUrl: 'soccer/ilves.webp',
  },
  Marsaxlokk: {
    displayName: 'Marsaxlokk',
    logoUrl: 'soccer/marsaxlokk.webp',
  },
  Pyunik: {
    displayName: 'Pyunik',
    logoUrl: 'soccer/pyunik.webp',
  },
  Zira: {
    displayName: 'Zira',
    logoUrl: 'soccer/zira.webp',
  },
  'Torpedo Kutaisi': {
    displayName: 'Torpedo Kutaisi',
    logoUrl: 'soccer/torpedo_kutaisi.webp',
  },
  Glentoran: {
    displayName: 'Glentoran',
    logoUrl: 'soccer/glentoran.webp',
  },
  'Rigas FS': {
    displayName: 'Rigas FS',
    logoUrl: 'soccer/rigas_fs.webp',
  },
  'Caernarfon Town': {
    displayName: 'Caernarfon Town',
    logoUrl: 'soccer/caernarfon_town.webp',
  },
  'FCI Levadia': {
    displayName: 'FCI Levadia',
    logoUrl: 'soccer/fci_levadia.webp',
  },
  Penybont: {
    displayName: 'Penybont',
    logoUrl: 'soccer/penybont.webp',
  },
  'FC Santa Coloma': {
    displayName: 'FC Santa Coloma',
    logoUrl: 'soccer/fc_santa_coloma.webp',
  },
  Petrovac: {
    displayName: 'Petrovac',
    logoUrl: 'soccer/petrovac.webp',
  },
  Mondorf: {
    displayName: 'Mondorf',
    logoUrl: 'soccer/mondorf.webp',
  },
  'Dinamo Tbilisi': {
    displayName: 'Dinamo Tbilisi',
    logoUrl: 'soccer/dinamo_tbilisi.webp',
  },
  Stjarnan: {
    displayName: 'Stjarnan',
    logoUrl: 'soccer/stjarnan.webp',
  },
  Milsami: {
    displayName: 'Milsami',
    logoUrl: 'soccer/milsami.webp',
  },
  'AF Elbasani': {
    displayName: 'AF Elbasani',
    logoUrl: 'soccer/af_elbasani.webp',
  },
  BATE: {
    displayName: 'BATE',
    logoUrl: 'soccer/bate.webp',
  },
  'CSKA Sofia': {
    displayName: 'CSKA Sofia',
    logoUrl: 'soccer/cska_sofia.webp',
  },
  'Derry City FC': {
    displayName: 'Derry City FC',
    logoUrl: 'soccer/derry_city_fc.webp',
  },
  'Dynamo Kyiv': {
    displayName: 'Dynamo Kyiv',
    logoUrl: 'soccer/dynamo_kyiv.webp',
  },
  'U. Cluj': {
    displayName: 'U. Cluj',
    logoUrl: 'soccer/u_cluj.webp',
  },
  NSI: {
    displayName: 'NSI',
    logoUrl: 'soccer/nsi.webp',
  },
  'Hamrun Spartans': {
    displayName: 'Hamrun Spartans',
    logoUrl: 'soccer/hamrun_spartans.webp',
  },
  Sheriff: {
    displayName: 'Sheriff',
    logoUrl: 'soccer/sheriff.webp',
  },
  Aluminij: {
    displayName: 'Aluminij',
    logoUrl: 'soccer/aluminij.webp',
  },
  'Dinamo Minsk': {
    displayName: 'Dinamo Minsk',
    logoUrl: 'soccer/dinamo_minsk.webp',
  },
  Sileks: {
    displayName: 'Sileks',
    logoUrl: 'soccer/sileks.webp',
  },
  "Connah's Quay": {
    displayName: "Connah's Quay",
    logoUrl: 'soccer/connahs_quay.webp',
  },
  Ballkani: {
    displayName: 'Ballkani',
    logoUrl: 'soccer/ballkani.webp',
  },
  Europa: {
    displayName: 'Europa',
    logoUrl: 'soccer/europa.webp',
  },
  Shkendija: {
    displayName: 'Shkendija',
    logoUrl: 'soccer/shkendija.webp',
  },
  Vojvodina: {
    displayName: 'Vojvodina',
    logoUrl: 'soccer/vojvodina.webp',
  },
  'Ferencvarosi Budapest': {
    displayName: 'Ferencvarosi Budapest',
    logoUrl: 'soccer/ferencvarosi_budapest.webp',
  },
  'Hajduk Split': {
    displayName: 'Hajduk Split',
    logoUrl: 'soccer/hajduk_split.webp',
  },
  Zilina: {
    displayName: 'Zilina',
    logoUrl: 'soccer/zilina.webp',
  },
  Kalju: {
    displayName: 'Kalju',
    logoUrl: 'soccer/kalju.webp',
  },
  Linfield: {
    displayName: 'Linfield',
    logoUrl: 'soccer/linfield.webp',
  },
  "Atletic Club d'Escaldes": {
    displayName: "Atletic Club d'Escaldes",
    logoUrl: 'soccer/atletic_club_descaldes.webp',
  },
  Mornar: {
    displayName: 'Mornar',
    logoUrl: 'soccer/mornar.webp',
  },
  Dila: {
    displayName: 'Dila',
    logoUrl: 'soccer/dila.webp',
  },
  Virtus: {
    displayName: 'Virtus',
    logoUrl: 'soccer/virtus.webp',
  },
  Vestri: {
    displayName: 'Vestri',
    logoUrl: 'soccer/vestri.webp',
  },
  'AC Monza': {
    displayName: 'AC Monza',
    logoUrl: 'soccer/ac_monza.webp',
  },
  'Venezia FC': {
    displayName: 'Venezia FC',
    logoUrl: 'soccer/venezia_fc.webp',
  },
  'Frosinone Calcio': {
    displayName: 'Frosinone Calcio',
    logoUrl: 'soccer/frosinone_calcio.webp',
  },
  'SV 07 Elversberg': {
    displayName: 'SV 07 Elversberg',
    logoUrl: 'soccer/sv_07_elversberg.webp',
  },
  'Schalke 04': {
    displayName: 'Schalke 04',
    logoUrl: 'soccer/schalke_04.webp',
  },
  'Santos FC SP': {
    displayName: 'Santos FC SP',
    logoUrl: 'soccer/santos_fc_sp.webp',
  },
  'Botafogo FR RJ': {
    displayName: 'Botafogo FR RJ',
    logoUrl: 'soccer/botafogo_fr_rj.webp',
  },
  'CR Vasco da Gama RJ': {
    displayName: 'CR Vasco da Gama RJ',
    logoUrl: 'soccer/cr_vasco_da_gama_rj.webp',
  },
  'EC Vitoria BA': {
    displayName: 'EC Vitoria BA',
    logoUrl: 'soccer/ec_vitoria_ba.webp',
  },
  Pacific: {
    displayName: 'Pacific',
    logoUrl: 'soccer/pacific.webp',
  },
  Forge: {
    displayName: 'Forge',
    logoUrl: 'soccer/forge.webp',
  },
  Atlante: {
    displayName: 'Atlante',
    logoUrl: 'soccer/atlante.webp',
  },
  'Juan Pablo II College': {
    displayName: 'Juan Pablo II College',
    logoUrl: 'soccer/juan_pablo_ii_college.webp',
  },
  'FC Cajamarca': {
    displayName: 'FC Cajamarca',
    logoUrl: 'soccer/fc_cajamarca.webp',
  },
  'Deportivo Garcilaso': {
    displayName: 'Deportivo Garcilaso',
    logoUrl: 'soccer/deportivo_garcilaso.webp',
  },
  'Chapecoense SC': {
    displayName: 'Chapecoense SC',
    logoUrl: 'soccer/chapecoense_sc.webp',
  },
  'EC Bahia BA': {
    displayName: 'EC Bahia BA',
    logoUrl: 'soccer/ec_bahia_ba.webp',
  },
  'Red Bull Bragantino SP': {
    displayName: 'Red Bull Bragantino SP',
    logoUrl: 'soccer/red_bull_bragantino_sp.webp',
  },
  'Gremio FB Porto Alegrense RS': {
    displayName: 'Gremio FB Porto Alegrense RS',
    logoUrl: 'soccer/gremio_fb_porto_alegrense_rs.webp',
  },
  'Vancouver FC': {
    displayName: 'Vancouver FC',
    logoUrl: 'soccer/vancouver_fc.webp',
  },
  'Supra du Quebec': {
    displayName: 'Supra du Quebec',
    logoUrl: 'soccer/supra_du_quebec.webp',
  },
  'York United': {
    displayName: 'York United',
    logoUrl: 'soccer/york_united.webp',
  },
  'Atletico Ottawa': {
    displayName: 'Atletico Ottawa',
    logoUrl: 'soccer/atletico_ottawa.webp',
  },
  'FBC Melgar': {
    displayName: 'FBC Melgar',
    logoUrl: 'soccer/fbc_melgar.webp',
  },
  'CS Cienciano': {
    displayName: 'CS Cienciano',
    logoUrl: 'soccer/cs_cienciano.webp',
  },
  'Comerciantes Unidos': {
    displayName: 'Comerciantes Unidos',
    logoUrl: 'soccer/comerciantes_unidos.webp',
  },
  'CD Moquegua': {
    displayName: 'CD Moquegua',
    logoUrl: 'soccer/cd_moquegua.webp',
  },
  'Louisville City FC': {
    displayName: 'Louisville City FC',
    logoUrl: 'soccer/louisville_city_fc.webp',
  },
  'Asociacion Deportiva Tarma': {
    displayName: 'Asociacion Deportiva Tarma',
    logoUrl: 'soccer/asociacion_deportiva_tarma.webp',
  },
  'HFX Wanderers': {
    displayName: 'HFX Wanderers',
    logoUrl: 'soccer/hfx_wanderers.webp',
  },
  Cavalry: {
    displayName: 'Cavalry',
    logoUrl: 'soccer/cavalry.webp',
  },
  'UTC de Cajamarca': {
    displayName: 'UTC de Cajamarca',
    logoUrl: 'soccer/utc_de_cajamarca.webp',
  },
  'Atletico Grau': {
    displayName: 'Atletico Grau',
    logoUrl: 'soccer/atletico_grau.webp',
  },
  'Indy Eleven': {
    displayName: 'Indy Eleven',
    logoUrl: 'soccer/indy_eleven.webp',
  },
  'Detroit City FC': {
    displayName: 'Detroit City FC',
    logoUrl: 'soccer/detroit_city_fc.webp',
  },
  'Tampa Bay Rowdies': {
    displayName: 'Tampa Bay Rowdies',
    logoUrl: 'soccer/tampa_bay_rowdies.webp',
  },
  'Loudoun United FC': {
    displayName: 'Loudoun United FC',
    logoUrl: 'soccer/loudoun_united_fc.webp',
  },
  'Brooklyn FC': {
    displayName: 'Brooklyn FC',
    logoUrl: 'soccer/brooklyn_fc.webp',
  },
  'Alianza Atletico': {
    displayName: 'Alianza Atletico',
    logoUrl: 'soccer/alianza_atletico.webp',
  },
  'Hartford Athletic': {
    displayName: 'Hartford Athletic',
    logoUrl: 'soccer/hartford_athletic.webp',
  },
  'Rhode Island FC': {
    displayName: 'Rhode Island FC',
    logoUrl: 'soccer/rhode_island_fc.webp',
  },
  'Sacramento Republic FC': {
    displayName: 'Sacramento Republic FC',
    logoUrl: 'soccer/sacramento_republic_fc.webp',
  },
  'Charleston Battery': {
    displayName: 'Charleston Battery',
    logoUrl: 'soccer/charleston_battery.webp',
  },
  'El Paso Locomotive FC': {
    displayName: 'El Paso Locomotive FC',
    logoUrl: 'soccer/el_paso_locomotive_fc.webp',
  },
  'FC Tulsa': {
    displayName: 'FC Tulsa',
    logoUrl: 'soccer/fc_tulsa.webp',
  },
  'Las Vegas Lights': {
    displayName: 'Las Vegas Lights',
    logoUrl: 'soccer/las_vegas_lights.webp',
  },
  'San Antonio FC': {
    displayName: 'San Antonio FC',
    logoUrl: 'soccer/san_antonio_fc.webp',
  },
  'Deportivo Toluca': {
    displayName: 'Deportivo Toluca',
    logoUrl: 'soccer/deportivo_toluca_fc.webp',
  },
  'Monterey Bay FC': {
    displayName: 'Monterey Bay FC',
    logoUrl: 'soccer/monterey_bay_fc.webp',
  },
  'Phoenix Rising FC': {
    displayName: 'Phoenix Rising FC',
    logoUrl: 'soccer/phoenix_rising_fc.webp',
  },
  'Sport Boys Association': {
    displayName: 'Sport Boys Association',
    logoUrl: 'soccer/sport_boys_association.webp',
  },
  'Los Chankas CYC': {
    displayName: 'Los Chankas CYC',
    logoUrl: 'soccer/los_chankas_cyc.webp',
  },
  'Sport Huancayo': {
    displayName: 'Sport Huancayo',
    logoUrl: 'soccer/sport_huancayo.webp',
  },
  'Alianza Lima': {
    displayName: 'Alianza Lima',
    logoUrl: 'soccer/alianza_lima.webp',
  },
  'Slovan Bratislava': {
    displayName: 'Slovan Bratislava',
    logoUrl: 'soccer/slovan_bratislava.webp',
  },
  Mjallby: {
    displayName: 'Mjallby',
    logoUrl: 'soccer/mjallby.webp',
  },
  'KKS Lech Poznan': {
    displayName: 'KKS Lech Poznan',
    logoUrl: 'soccer/kks_lech_poznan.webp',
  },
  Aarhus: {
    displayName: 'Aarhus',
    logoUrl: 'soccer/aarhus.webp',
  },
  'Gornik Zabrze': {
    displayName: 'Gornik Zabrze',
    logoUrl: 'soccer/gornik_zabrze.webp',
  },
  'Fenerbahce Istanbul': {
    displayName: 'Fenerbahce Istanbul',
    logoUrl: 'soccer/fenerbahce_istanbul.webp',
  },
  'Dinamo Zagreb': {
    displayName: 'Dinamo Zagreb',
    logoUrl: 'soccer/dinamo_zagreb.webp',
  },
  Thun: {
    displayName: 'Thun',
    logoUrl: 'soccer/thun.webp',
  },
  Hearts: {
    displayName: 'Hearts',
    logoUrl: 'soccer/hearts.webp',
  },
  'Sturm Graz': {
    displayName: 'Sturm Graz',
    logoUrl: 'soccer/sturm_graz.webp',
  },
  KI: {
    displayName: 'KI',
    logoUrl: 'soccer/ki.webp',
  },
  'Crvena Zvezda': {
    displayName: 'Crvena Zvezda',
    logoUrl: 'soccer/crvena_zvezda.webp',
  },
  'Hapoel Beer Sheva': {
    displayName: 'Hapoel Beer Sheva',
    logoUrl: 'soccer/hapoel_beer_sheva.webp',
  },
  'Atletico Mineiro MG': {
    displayName: 'Atletico Mineiro MG',
    logoUrl: 'soccer/atletico_mineiro_mg.webp',
  },
  'Atletico Mineiro': {
    displayName: 'Atletico Mineiro',
    logoUrl: 'soccer/atletico_mineiro_mg.webp',
  },
  Santos: {
    displayName: 'Santos',
    logoUrl: 'soccer/santos.webp',
  },
  'Universidad Central': {
    displayName: 'Universidad Central',
    logoUrl: 'soccer/universidad_central.webp',
  },
  Kairat: {
    displayName: 'Kairat',
    logoUrl: 'soccer/kairat.webp',
  },
  'Omonia Nicosia': {
    displayName: 'Omonia Nicosia',
    logoUrl: 'soccer/omonia_nicosia.webp',
  },
  'CSKA 1948 Sofia': {
    displayName: 'CSKA 1948 Sofia',
    logoUrl: 'soccer/cska_1948_sofia.webp',
  },
  'Spartak Trnava': {
    displayName: 'Spartak Trnava',
    logoUrl: 'soccer/spartak_trnava.webp',
  },
  'NK Celje': {
    displayName: 'NK Celje',
    logoUrl: 'soccer/nk_celje.webp',
  },
  'Coritiba FC PR': {
    displayName: 'Coritiba FC PR',
    logoUrl: 'soccer/coritiba_fc_pr.webp',
  },
  'Oakland Roots SC': {
    displayName: 'Oakland Roots SC',
    logoUrl: 'soccer/oakland_roots_sc.webp',
  },
  'Lexington SC': {
    displayName: 'Lexington SC',
    logoUrl: 'soccer/lexington_sc.webp',
  },
  'CA Paranaense PR': {
    displayName: 'CA Paranaense PR',
    logoUrl: 'soccer/ca_paranaense_pr.webp',
  },
  'Sao Paulo FC SP': {
    displayName: 'Sao Paulo FC SP',
    logoUrl: 'soccer/sao_paulo_fc_sp.webp',
  },
  'Internacional RS': {
    displayName: 'Internacional RS',
    logoUrl: 'soccer/internacional_rs.webp',
  },
  'Miami FC': {
    displayName: 'Miami FC',
    logoUrl: 'soccer/miami_fc.webp',
  },
  'Colorado Springs Switchbacks FC': {
    displayName: 'Colorado Springs Switchbacks FC',
    logoUrl: 'soccer/colorado_springs_switchbacks_fc.webp',
  },
  'RSC Anderlecht': {
    displayName: 'RSC Anderlecht',
    logoUrl: 'soccer/rsc_anderlecht.webp',
  },
  Hammarby: {
    displayName: 'Hammarby',
    logoUrl: 'soccer/hammarby.webp',
  },
  'FC Midtjylland': {
    displayName: 'FC Midtjylland',
    logoUrl: 'soccer/fc_midtjylland.webp',
  },
  'Besiktas Istanbul': {
    displayName: 'Besiktas Istanbul',
    logoUrl: 'soccer/besiktas_istanbul.webp',
  },
  'St. Gallen': {
    displayName: 'St. Gallen',
    logoUrl: 'soccer/st_gallen.webp',
  },
  'Hradec Kralove': {
    displayName: 'Hradec Kralove',
    logoUrl: 'soccer/hradec_kralove.webp',
  },
  'SC Braga': {
    displayName: 'SC Braga',
    logoUrl: 'soccer/sc_braga.webp',
  },
  'Zeleznicar Pancevo': {
    displayName: 'Zeleznicar Pancevo',
    logoUrl: 'soccer/zeleznicar_pancevo.webp',
  },
  Nordsjlland: {
    displayName: 'Nordsjlland',
    logoUrl: 'soccer/nordsjlland.webp',
  },
  GAIS: {
    displayName: 'GAIS',
    logoUrl: 'soccer/gais.webp',
  },
  Zrinjski: {
    displayName: 'Zrinjski',
    logoUrl: 'soccer/zrinjski.webp',
  },
  Valur: {
    displayName: 'Valur',
    logoUrl: 'soccer/valur.webp',
  },
  Gent: {
    displayName: 'Gent',
    logoUrl: 'soccer/gent.webp',
  },
  'LNZ Cherkasy': {
    displayName: 'LNZ Cherkasy',
    logoUrl: 'soccer/lnz_cherkasy.webp',
  },
  Coleraine: {
    displayName: 'Coleraine',
    logoUrl: 'soccer/coleraine.webp',
  },
  HJK: {
    displayName: 'HJK',
    logoUrl: 'soccer/hjk.webp',
  },
  'Beitar Jerusalem': {
    displayName: 'Beitar Jerusalem',
    logoUrl: 'soccer/beitar_jerusalem.webp',
  },
  'AEK Larnaca': {
    displayName: 'AEK Larnaca',
    logoUrl: 'soccer/aek_larnaca.webp',
  },
  'Panathinaikos Athens': {
    displayName: 'Panathinaikos Athens',
    logoUrl: 'soccer/panathinaikos_athens.webp',
  },
  Paks: {
    displayName: 'Paks',
    logoUrl: 'soccer/paks.webp',
  },
  Polissya: {
    displayName: 'Polissya',
    logoUrl: 'soccer/polissya.webp',
  },
  Ludogorets: {
    displayName: 'Ludogorets',
    logoUrl: 'soccer/ludogorets.webp',
  },
  'Hapoel Tel Aviv': {
    displayName: 'Hapoel Tel Aviv',
    logoUrl: 'soccer/hapoel_tel_aviv.webp',
  },
  Dukagjini: {
    displayName: 'Dukagjini',
    logoUrl: 'soccer/dukagjini.webp',
  },
  Lugano: {
    displayName: 'Lugano',
    logoUrl: 'soccer/lugano.webp',
  },
  Tobol: {
    displayName: 'Tobol',
    logoUrl: 'soccer/tobol.webp',
  },
  Panevezys: {
    displayName: 'Panevezys',
    logoUrl: 'soccer/panevezys.webp',
  },
  Auda: {
    displayName: 'Auda',
    logoUrl: 'soccer/auda.webp',
  },
  FCSB: {
    displayName: 'FCSB',
    logoUrl: 'soccer/fcsb.webp',
  },
  Valletta: {
    displayName: 'Valletta',
    logoUrl: 'soccer/valletta.webp',
  },
  'RKS Rakow Czestochowa': {
    displayName: 'RKS Rakow Czestochowa',
    logoUrl: 'soccer/rks_rakow_czestochowa.webp',
  },
  Noah: {
    displayName: 'Noah',
    logoUrl: 'soccer/noah.webp',
  },
  Zimbru: {
    displayName: 'Zimbru',
    logoUrl: 'soccer/zimbru.webp',
  },
  HB: {
    displayName: 'HB',
    logoUrl: 'soccer/hb.webp',
  },
  'Motherwell FC': {
    displayName: 'Motherwell FC',
    logoUrl: 'soccer/motherwell_fc.webp',
  },
  'The New Saints': {
    displayName: 'The New Saints',
    logoUrl: 'soccer/the_new_saints_fc.webp',
  },
  Partizan: {
    displayName: 'Partizan',
    logoUrl: 'soccer/partizan.webp',
  },
  'Austria Vienna': {
    displayName: 'Austria Vienna',
    logoUrl: 'soccer/austria_vienna.webp',
  },
  'Hibernian FC': {
    displayName: 'Hibernian FC',
    logoUrl: 'soccer/hibernian_fc.webp',
  },
  Jablonec: {
    displayName: 'Jablonec',
    logoUrl: 'soccer/jablonec.webp',
  },
  Varazdin: {
    displayName: 'Varazdin',
    logoUrl: 'soccer/varazdin.webp',
  },
  'Clube do Remo PA': {
    displayName: 'Clube do Remo PA',
    logoUrl: 'soccer/clube_do_remo_pa.webp',
  },
  Caracas: {
    displayName: 'Caracas',
    logoUrl: 'soccer/caracas.webp',
  },
  "O'Higgins": {
    displayName: "O'Higgins",
    logoUrl: 'soccer/o_higgins.webp',
  },
  Pafos: {
    displayName: 'Pafos',
    logoUrl: 'soccer/pafos_fc.webp',
  },
  'PAOK FC': {
    displayName: 'PAOK FC',
    logoUrl: 'soccer/paok_fc.webp',
  },
  'Maccabi Tel Aviv': {
    displayName: 'Maccabi Tel Aviv',
    logoUrl: 'soccer/maccabi_tel_aviv.webp',
  },
  Twente: {
    displayName: 'Twente',
    logoUrl: 'soccer/twente.webp',
  },
  'CFR Cluj': {
    displayName: 'CFR Cluj',
    logoUrl: 'soccer/cfr_cluj.webp',
  },
  Debrecen: {
    displayName: 'Debrecen',
    logoUrl: 'soccer/debrecen.webp',
  },
  Apollon: {
    displayName: 'Apollon',
    logoUrl: 'soccer/apollon.webp',
  },
  'DAC 1904': {
    displayName: 'DAC 1904',
    logoUrl: 'soccer/dac_1904.webp',
  },
  // API-discovered soccer/all logo placeholders. Add matching CDN assets for these paths.
  'AGF Aarhus': {
    displayName: 'AGF Aarhus',
    logoUrl: 'soccer/agf_aarhus.webp',
  },
  'AIK Stockholm': {
    displayName: 'AIK Stockholm',
    logoUrl: 'soccer/aik_stockholm.webp',
  },
  'Birmingham Legion FC': {
    displayName: 'Birmingham Legion FC',
    logoUrl: 'soccer/birmingham_legion_fc.webp',
  },
  'BK Hacken': {
    displayName: 'BK Hacken',
    logoUrl: 'soccer/bk_hacken.webp',
  },
  'Broendby IF': {
    displayName: 'Broendby IF',
    logoUrl: 'soccer/broendby_if.webp',
  },
  Brommapojkarna: {
    displayName: 'Brommapojkarna',
    logoUrl: 'soccer/brommapojkarna.webp',
  },
  'CSKA Moscow': {
    displayName: 'CSKA Moscow',
    logoUrl: 'soccer/cska_moscow.webp',
  },
  Degerfors: {
    displayName: 'Degerfors',
    logoUrl: 'soccer/degerfors.webp',
  },
  'Deportivo Riestra': {
    displayName: 'Deportivo Riestra',
    logoUrl: 'soccer/deportivo_riestra.webp',
  },
  'Djurgardens IF': {
    displayName: 'Djurgardens IF',
    logoUrl: 'soccer/djurgardens_if.webp',
  },
  Fakel: {
    displayName: 'Fakel',
    logoUrl: 'soccer/fakel.webp',
  },
  'FC Baltika Kaliningrad': {
    displayName: 'FC Baltika Kaliningrad',
    logoUrl: 'soccer/fc_baltika_kaliningrad.webp',
  },
  'FC Dynamo-Makhachkala': {
    displayName: 'FC Dynamo-Makhachkala',
    logoUrl: 'soccer/fc_dynamo_makhachkala.webp',
  },
  'FC Nordsjaelland': {
    displayName: 'FC Nordsjaelland',
    logoUrl: 'soccer/fc_nordsjaelland.webp',
  },
  'FC Orenburg': {
    displayName: 'FC Orenburg',
    logoUrl: 'soccer/fc_orenburg.webp',
  },
  'FK Akron Tolyatti': {
    displayName: 'FK Akron Tolyatti',
    logoUrl: 'soccer/fk_akron_tolyatti.webp',
  },
  'FK Dinamo Moscow': {
    displayName: 'FK Dinamo Moscow',
    logoUrl: 'soccer/fk_dinamo_moscow.webp',
  },
  'FK Krasnodar': {
    displayName: 'FK Krasnodar',
    logoUrl: 'soccer/fk_krasnodar.webp',
  },
  'FK Rostov': {
    displayName: 'FK Rostov',
    logoUrl: 'soccer/fk_rostov.webp',
  },
  'FK Rubin Kazan': {
    displayName: 'FK Rubin Kazan',
    logoUrl: 'soccer/fk_rubin_kazan.webp',
  },
  'FK Spartak Moscow': {
    displayName: 'FK Spartak Moscow',
    logoUrl: 'soccer/fk_spartak_moscow.webp',
  },
  'FK Zenit Saint Petersburg': {
    displayName: 'FK Zenit Saint Petersburg',
    logoUrl: 'soccer/fk_zenit_saint_petersburg.webp',
  },
  Halmstads: {
    displayName: 'Halmstads',
    logoUrl: 'soccer/halmstads.webp',
  },
  'Hammarby IF': {
    displayName: 'Hammarby IF',
    logoUrl: 'soccer/hammarby_if.webp',
  },
  Horsens: {
    displayName: 'Horsens',
    logoUrl: 'soccer/horsens.webp',
  },
  'IF Elfsborg': {
    displayName: 'IF Elfsborg',
    logoUrl: 'soccer/if_elfsborg.webp',
  },
  'IFK Goteborg': {
    displayName: 'IFK Goteborg',
    logoUrl: 'soccer/ifk_goteborg.webp',
  },
  Independiente: {
    displayName: 'Independiente',
    logoUrl: 'soccer/independiente.webp',
  },
  'Kalmar FF': {
    displayName: 'Kalmar FF',
    logoUrl: 'soccer/kalmar_ff.webp',
  },
  'Liga MX All-Stars': {
    displayName: 'Liga MX All-Stars',
    logoUrl: 'soccer/liga_mx_all_stars.webp',
  },
  'Lokomotiv Moscow': {
    displayName: 'Lokomotiv Moscow',
    logoUrl: 'soccer/lokomotiv_moscow.webp',
  },
  Lyngby: {
    displayName: 'Lyngby',
    logoUrl: 'soccer/lyngby.webp',
  },
  'Malmo FF': {
    displayName: 'Malmo FF',
    logoUrl: 'soccer/malmo_ff.webp',
  },
  'MLS All-Stars': {
    displayName: 'MLS All-Stars',
    logoUrl: 'soccer/mls_all_stars.webp',
  },
  'New Mexico United': {
    displayName: 'New Mexico United',
    logoUrl: 'soccer/new_mexico_united.webp',
  },
  'Odense Boldklub': {
    displayName: 'Odense Boldklub',
    logoUrl: 'soccer/odense_boldklub.webp',
  },
  'Orange County SC': {
    displayName: 'Orange County SC',
    logoUrl: 'soccer/orange_county_sc.webp',
  },
  Orgryte: {
    displayName: 'Orgryte',
    logoUrl: 'soccer/orgryte.webp',
  },
  'PFK Krylia Sovetov Samara': {
    displayName: 'PFK Krylia Sovetov Samara',
    logoUrl: 'soccer/pfk_krylia_sovetov_samara.webp',
  },
  'Randers FC': {
    displayName: 'Randers FC',
    logoUrl: 'soccer/randers_fc.webp',
  },
  'RFK Akhmat Grozny': {
    displayName: 'RFK Akhmat Grozny',
    logoUrl: 'soccer/rfk_akhmat_grozny.webp',
  },
  'Rodina Moskva': {
    displayName: 'Rodina Moskva',
    logoUrl: 'soccer/rodina_moskva.webp',
  },
  'Silkeborg IF': {
    displayName: 'Silkeborg IF',
    logoUrl: 'soccer/silkeborg_if.webp',
  },
  Sirius: {
    displayName: 'Sirius',
    logoUrl: 'soccer/sirius.webp',
  },
  Soenderjyske: {
    displayName: 'Soenderjyske',
    logoUrl: 'soccer/soenderjyske.webp',
  },
  'Vasteras SK': {
    displayName: 'Vasteras SK',
    logoUrl: 'soccer/vasteras_sk.webp',
  },
  'Viborg FF': {
    displayName: 'Viborg FF',
    logoUrl: 'soccer/viborg_ff.webp',
  },
  'Alianza': {
    displayName: 'Alianza',
    logoUrl: 'soccer/alianza.webp',
  },
  'Antigua GFC': {
    displayName: 'Antigua GFC',
    logoUrl: 'soccer/antigua_gfc.webp',
  },
  'Birmingham Legion': {
    displayName: 'Birmingham Legion',
    logoUrl: 'soccer/birmingham_legion_fc.webp',
  },
  'Bravo': {
    displayName: 'Bravo',
    logoUrl: 'soccer/bravo.webp',
  },
  'Cartagines': {
    displayName: 'Cartagines',
    logoUrl: 'soccer/cartagines.webp',
  },
  'Celtic Glasgow': {
    displayName: 'Celtic Glasgow',
    logoUrl: 'soccer/celtic_glasgow.webp',
  },
  'Diriangen': {
    displayName: 'Diriangen',
    logoUrl: 'soccer/diriangen.webp',
  },
  'Dundee FC': {
    displayName: 'Dundee FC',
    logoUrl: 'soccer/dundee_fc.webp',
  },
  'Dundee United': {
    displayName: 'Dundee United',
    logoUrl: 'soccer/dundee_united.webp',
  },
  'Falkirk FC': {
    displayName: 'Falkirk FC',
    logoUrl: 'soccer/falkirk_fc.webp',
  },
  'GKS Katowice': {
    displayName: 'GKS Katowice',
    logoUrl: 'soccer/gks_katowice.webp',
  },
  'Glasgow Rangers': {
    displayName: 'Glasgow Rangers',
    logoUrl: 'soccer/glasgow_rangers.webp',
  },
  'Goteborg': {
    displayName: 'Goteborg',
    logoUrl: 'soccer/ifk_goteborg.webp',
  },
  'Herediano': {
    displayName: 'Herediano',
    logoUrl: 'soccer/herediano.webp',
  },
  'HNK Rijeka': {
    displayName: 'HNK Rijeka',
    logoUrl: 'soccer/hnk_rijeka.webp',
  },
  'Istanbul Basaksehir': {
    displayName: 'Istanbul Basaksehir',
    logoUrl: 'soccer/istanbul_basaksehir.webp',
  },
  'Kilmarnock FC': {
    displayName: 'Kilmarnock FC',
    logoUrl: 'soccer/kilmarnock_fc.webp',
  },
  'Koper': {
    displayName: 'Koper',
    logoUrl: 'soccer/koper.webp',
  },
  'Liga Deportiva Alajuelense': {
    displayName: 'Liga Deportiva Alajuelense',
    logoUrl: 'soccer/liga_deportiva_alajuelense.webp',
  },
  'Marathon': {
    displayName: 'Marathon',
    logoUrl: 'soccer/marathon.webp',
  },
  'Mixco': {
    displayName: 'Mixco',
    logoUrl: 'soccer/mixco.webp',
  },
  'Motagua': {
    displayName: 'Motagua',
    logoUrl: 'soccer/motagua.webp',
  },
  'Municipal': {
    displayName: 'Municipal',
    logoUrl: 'soccer/municipal.webp',
  },
  'Neftchi Baku': {
    displayName: 'Neftchi Baku',
    logoUrl: 'soccer/neftchi_baku.webp',
  },
  'Olimpia': {
    displayName: 'Olimpia',
    logoUrl: 'soccer/olimpia.webp',
  },
  'Olimpia Asuncion': {
    displayName: 'Olimpia Asuncion',
    logoUrl: 'soccer/olimpia.webp',
  },
  'Plaza Amador': {
    displayName: 'Plaza Amador',
    logoUrl: 'soccer/plaza_amador.webp',
  },
  'Rapid Vienna': {
    displayName: 'Rapid Vienna',
    logoUrl: 'soccer/rapid_vienna.webp',
  },
  'Saprissa': {
    displayName: 'Saprissa',
    logoUrl: 'soccer/saprissa.webp',
  },
  'Shelbourne FC': {
    displayName: 'Shelbourne FC',
    logoUrl: 'soccer/shelbourne_fc.webp',
  },
  'Sion': {
    displayName: 'Sion',
    logoUrl: 'soccer/sion.webp',
  },
  'St Mirren FC': {
    displayName: 'St Mirren FC',
    logoUrl: 'soccer/st_mirren_fc.webp',
  },
  'St. Johnstone': {
    displayName: 'St. Johnstone',
    logoUrl: 'soccer/st_johnstone.webp',
  },
  'U Cluj': {
    displayName: 'U Cluj',
    logoUrl: 'soccer/u_cluj.webp',
  },
  'UMECIT': {
    displayName: 'UMECIT',
    logoUrl: 'soccer/umecit.webp',
  },
  'Vaduz': {
    displayName: 'Vaduz',
    logoUrl: 'soccer/vaduz.webp',
  },
  'Verdes FC': {
    displayName: 'Verdes FC',
    logoUrl: 'soccer/verdes_fc.webp',
  },
  'Xelaju': {
    displayName: 'Xelaju',
    logoUrl: 'soccer/xelaju.webp',
  },
  'Aberdeen FC': {
    displayName: 'Aberdeen FC',
    logoUrl: 'soccer/aberdeen_fc.webp',
  },
  'Club Atletico Guemes': {
    displayName: 'Club Atletico Guemes',
    logoUrl: 'soccer/club_atletico_guemes.webp',
  },
  'CS U Craiova': {
    displayName: 'CS U Craiova',
    logoUrl: 'soccer/cs_u_craiova.webp',
  },
  Egnatia: {
    displayName: 'Egnatia',
    logoUrl: 'soccer/egnatia.webp',
  },
  Esteli: {
    displayName: 'Esteli',
    logoUrl: 'soccer/esteli.webp',
  },
  'Glasgow Rangers': {
    displayName: 'Glasgow Rangers',
    logoUrl: 'soccer/glasgow_rangers.webp',
  },
  'Heart of Midlothian FC': {
    displayName: 'Heart of Midlothian FC',
    logoUrl: 'soccer/heart_of_midlothian_fc.webp',
  },
  'Jagiellonia Bialystok': {
    displayName: 'Jagiellonia Bialystok',
    logoUrl: 'soccer/jagiellonia_bialystok.webp',
  },
  'Le Mans FC': {
    displayName: 'Le Mans FC',
    logoUrl: 'soccer/le_mans_fc.webp',
  },
  'Luis Angel Firpo': {
    displayName: 'Luis Angel Firpo',
    logoUrl: 'soccer/luis_angel_firpo.webp',
  },
  Nijmegen: {
    displayName: 'Nijmegen',
    logoUrl: 'soccer/nijmegen.webp',
  },
  'Sparta Praha': {
    displayName: 'Sparta Praha',
    logoUrl: 'soccer/sparta_praha.webp',
  },
  'Tristan Suarez': {
    displayName: 'Tristan Suarez',
    logoUrl: 'soccer/tristan_suarez.webp',
  },
  Troyes: {
    displayName: 'Troyes',
    logoUrl: 'soccer/troyes.webp',
  },
  'Mito Hollyhock': {
    displayName: 'Mito Hollyhock',
    logoUrl: 'soccer/mito_hollyhock.webp',
  },
  'Kashiwa Reysol': {
    displayName: 'Kashiwa Reysol',
    logoUrl: 'soccer/kashiwa_reysol.webp',
  },
  'Machida Zelvia': {
    displayName: 'Machida Zelvia',
    logoUrl: 'soccer/machida_zelvia.webp',
  },
  'FC Tokyo': {
    displayName: 'FC Tokyo',
    logoUrl: 'soccer/fc_tokyo.webp',
  },
  'Shimizu S-Pulse': {
    displayName: 'Shimizu S-Pulse',
    logoUrl: 'soccer/shimizu_s_pulse.webp',
  },
  'Nagoya Grampus': {
    displayName: 'Nagoya Grampus',
    logoUrl: 'soccer/nagoya_grampus.webp',
  },
  'Fagiano Okayama': {
    displayName: 'Fagiano Okayama',
    logoUrl: 'soccer/fagiano_okayama.webp',
  },
  'Cerezo Osaka': {
    displayName: 'Cerezo Osaka',
    logoUrl: 'soccer/cerezo_osaka.webp',
  },
  'Vissel Kobe': {
    displayName: 'Vissel Kobe',
    logoUrl: 'soccer/vissel_kobe.webp',
  },
  'Avispa Fukuoka': {
    displayName: 'Avispa Fukuoka',
    logoUrl: 'soccer/avispa_fukuoka.webp',
  },
  'JEF United Chiba': {
    displayName: 'JEF United Chiba',
    logoUrl: 'soccer/jef_united_chiba.webp',
  },
  'Sanfrecce Hiroshima': {
    displayName: 'Sanfrecce Hiroshima',
    logoUrl: 'soccer/sanfrecce_hiroshima.webp',
  },
  Osnabruck: {
    displayName: 'Osnabruck',
    logoUrl: 'soccer/osnabruck.webp',
  },
  'Arminia Bielefeld': {
    displayName: 'Arminia Bielefeld',
    logoUrl: 'soccer/arminia_bielefeld.webp',
  },
  'Karlsruher SC': {
    displayName: 'Karlsruher SC',
    logoUrl: 'soccer/karlsruher_sc.webp',
  },
  'Eintracht Braunschweig': {
    displayName: 'Eintracht Braunschweig',
    logoUrl: 'soccer/eintracht_braunschweig.webp',
  },
  '1. FC Magdeburg': {
    displayName: '1. FC Magdeburg',
    logoUrl: 'soccer/1_fc_magdeburg.webp',
  },
  'Holstein Kiel': {
    displayName: 'Holstein Kiel',
    logoUrl: 'soccer/holstein_kiel.webp',
  },
  'SV Darmstadt 98': {
    displayName: 'SV Darmstadt 98',
    logoUrl: 'soccer/sv_darmstadt_98.webp',
  },
  'SC Telstar': {
    displayName: 'SC Telstar',
    logoUrl: 'soccer/sc_telstar.webp',
  },
  'NEC Nijmegen': {
    displayName: 'NEC Nijmegen',
    logoUrl: 'soccer/nec_nijmegen.webp',
  },
  'Casa Pia': {
    displayName: 'Casa Pia',
    logoUrl: 'soccer/casa_pia.webp',
  },
  Maritimo: {
    displayName: 'Maritimo',
    logoUrl: 'soccer/maritimo.webp',
  },
  'Cercle Brugge': {
    displayName: 'Cercle Brugge',
    logoUrl: 'soccer/cercle_brugge.webp',
  },
  'Standard Liege': {
    displayName: 'Standard Liege',
    logoUrl: 'soccer/standard_liege.webp',
  },
  'Willem II': {
    displayName: 'Willem II',
    logoUrl: 'soccer/willem_ii.webp',
  },
  'Go Ahead Eagles': {
    displayName: 'Go Ahead Eagles',
    logoUrl: 'soccer/go_ahead_eagles.webp',
  },
  'FC Arouca': {
    displayName: 'FC Arouca',
    logoUrl: 'soccer/fc_arouca.webp',
  },
  'Vitoria SC Guimaraes': {
    displayName: 'Vitoria SC Guimaraes',
    logoUrl: 'soccer/vitoria_sc_guimaraes.webp',
  },
  Catania: {
    displayName: 'Catania',
    logoUrl: 'soccer/catania.webp',
  },
  'L R Vicenza': {
    displayName: 'L R Vicenza',
    logoUrl: 'soccer/l_r_vicenza.webp',
  },
  'Fortuna Sittard': {
    displayName: 'Fortuna Sittard',
    logoUrl: 'soccer/fortuna_sittard.webp',
  },
  'Rossoblu Potenza': {
    displayName: 'Rossoblu Potenza',
    logoUrl: 'soccer/rossoblu_potenza.webp',
  },
  'Ascoli Picchio': {
    displayName: 'Ascoli Picchio',
    logoUrl: 'soccer/ascoli_picchio.webp',
  },
  '1 FC Kaiserslautern': {
    displayName: '1 FC Kaiserslautern',
    logoUrl: 'soccer/1_fc_kaiserslautern.webp',
  },
  Lommel: {
    displayName: 'Lommel',
    logoUrl: 'soccer/lommel.webp',
  },
  'St. Truidense VV': {
    displayName: 'St. Truidense VV',
    logoUrl: 'soccer/st_truidense_vv.webp',
  },
  'KVC Westerlo': {
    displayName: 'KVC Westerlo',
    logoUrl: 'soccer/kvc_westerlo.webp',
  },
  'ADO Den Haag': {
    displayName: 'ADO Den Haag',
    logoUrl: 'soccer/ado_den_haag.webp',
  },
  'AZ Alkmaar': {
    displayName: 'AZ Alkmaar',
    logoUrl: 'soccer/az_alkmaar.webp',
  },
  'Estrela Amadora': {
    displayName: 'Estrela Amadora',
    logoUrl: 'soccer/estrela_amadora.webp',
  },
  'Kawasaki Frontale': {
    displayName: 'Kawasaki Frontale',
    logoUrl: 'soccer/kawasaki_frontale.webp',
  },
  'Tokyo Verdy': {
    displayName: 'Tokyo Verdy',
    logoUrl: 'soccer/tokyo_verdy.webp',
  },
  'Kyoto Sanga FC': {
    displayName: 'Kyoto Sanga FC',
    logoUrl: 'soccer/kyoto_sanga_fc.webp',
  },
  'V-Varen Nagasaki': {
    displayName: 'V-Varen Nagasaki',
    logoUrl: 'soccer/v_varen_nagasaki.webp',
  },
  'Feyenoord Rotterdam': {
    displayName: 'Feyenoord Rotterdam',
    logoUrl: 'soccer/feyenoord_rotterdam.webp',
  },
  'Sparta Rotterdam': {
    displayName: 'Sparta Rotterdam',
    logoUrl: 'soccer/sparta_rotterdam.webp',
  },
  'Greuther Furth': {
    displayName: 'Greuther Furth',
    logoUrl: 'soccer/greuther_furth.webp',
  },
  'Dynamo Dresden': {
    displayName: 'Dynamo Dresden',
    logoUrl: 'soccer/dynamo_dresden.webp',
  },
  '1 FC Nuremberg': {
    displayName: '1 FC Nuremberg',
    logoUrl: 'soccer/1_fc_nuremberg.webp',
  },
  'Hannover 96': {
    displayName: 'Hannover 96',
    logoUrl: 'soccer/hannover_96.webp',
  },
  Cottbus: {
    displayName: 'Cottbus',
    logoUrl: 'soccer/cottbus.webp',
  },
  'Yellow-Red KV Mechelen': {
    displayName: 'Yellow-Red KV Mechelen',
    logoUrl: 'soccer/yellow_red_kv_mechelen.webp',
  },
  'KAA Gent': {
    displayName: 'KAA Gent',
    logoUrl: 'soccer/kaa_gent.webp',
  },
  'FC Utrecht': {
    displayName: 'FC Utrecht',
    logoUrl: 'soccer/fc_utrecht.webp',
  },
  'FC Groningen': {
    displayName: 'FC Groningen',
    logoUrl: 'soccer/fc_groningen.webp',
  },
  'PEC Zwolle': {
    displayName: 'PEC Zwolle',
    logoUrl: 'soccer/pec_zwolle.webp',
  },
  'Oud-Heverlee Leuven': {
    displayName: 'Oud-Heverlee Leuven',
    logoUrl: 'soccer/oud_heverlee_leuven.webp',
  },
  'Royal Charleroi SC': {
    displayName: 'Royal Charleroi SC',
    logoUrl: 'soccer/royal_charleroi_sc.webp',
  },
  'KRC Genk': {
    displayName: 'KRC Genk',
    logoUrl: 'soccer/krc_genk.webp',
  },
  'SV Zulte Waregem': {
    displayName: 'SV Zulte Waregem',
    logoUrl: 'soccer/sv_zulte_waregem.webp',
  },
  'FC Twente Enschede': {
    displayName: 'FC Twente Enschede',
    logoUrl: 'soccer/fc_twente_enschede.webp',
  },
  'SC Heerenveen': {
    displayName: 'SC Heerenveen',
    logoUrl: 'soccer/sc_heerenveen.webp',
  },
  'RAAL La Louviere': {
    displayName: 'RAAL La Louviere',
    logoUrl: 'soccer/raal_la_louviere.webp',
  },
  'FC Alverca SAD': {
    displayName: 'FC Alverca SAD',
    logoUrl: 'soccer/fc_alverca_sad.webp',
  },
  'RS Waasland': {
    displayName: 'RS Waasland',
    logoUrl: 'soccer/rs_waasland.webp',
  },
  'Royal Antwerp FC': {
    displayName: 'Royal Antwerp FC',
    logoUrl: 'soccer/royal_antwerp_fc.webp',
  },
  Brescia: {
    displayName: 'Brescia',
    logoUrl: 'soccer/brescia.webp',
  },
  Arezzo: {
    displayName: 'Arezzo',
    logoUrl: 'soccer/arezzo.webp',
  },
  Ravenna: {
    displayName: 'Ravenna',
    logoUrl: 'soccer/ravenna.webp',
  },
  Benevento: {
    displayName: 'Benevento',
    logoUrl: 'soccer/benevento.webp',
  },
  'Academico Viseu': {
    displayName: 'Academico Viseu',
    logoUrl: 'soccer/academico_viseu.webp',
  },
  'Moreirense FC': {
    displayName: 'Moreirense FC',
    logoUrl: 'soccer/moreirense_fc.webp',
  },
  'Rio Ave FC': {
    displayName: 'Rio Ave FC',
    logoUrl: 'soccer/rio_ave_fc.webp',
  },
  'Gil Vicente Barcelos': {
    displayName: 'Gil Vicente Barcelos',
    logoUrl: 'soccer/gil_vicente_barcelos.webp',
  },
  Salzburg: {
    displayName: 'Salzburg',
    logoUrl: 'soccer/rb_salzburg.webp',
  },
  Qarabag: {
    displayName: 'Qarabag',
    logoUrl: 'soccer/qarabag_fk.webp',
  },
  'Dinamo Kiev': {
    displayName: 'Dinamo Kiev',
    logoUrl: 'soccer/dynamo_kyiv.webp',
  },
  'St.Gallen': {
    displayName: 'St.Gallen',
    logoUrl: 'soccer/st_gallen.webp',
  },
  Midtjylland: {
    displayName: 'Midtjylland',
    logoUrl: 'soccer/fc_midtjylland.webp',
  },
  'Club Nacional de Football': {
    displayName: 'Club Nacional de Football',
    logoUrl: 'soccer/club_nacional.webp',
  },
  'Santa Clara Azores': {
    displayName: 'Santa Clara Azores',
    logoUrl: 'soccer/santa_clara_azores.webp',
  },
  Recoleta: {
    displayName: 'Recoleta',
    logoUrl: 'soccer/recoleta.webp',
  },
  'Montevideo City': {
    displayName: 'Montevideo City',
    logoUrl: 'soccer/montevideo_city.webp',
  },
  'AEK Athens': {
    displayName: 'AEK Athens',
    logoUrl: 'soccer/aek_athens.webp',
  },
  LASK: {
    displayName: 'LASK',
    logoUrl: 'soccer/lask.webp',
  },
  'Viktoria Plzen': {
    displayName: 'Viktoria Plzen',
    logoUrl: 'soccer/viktoria_plzen.webp',
  },
  'Bradford City FC': {
    displayName: 'Bradford City FC',
    logoUrl: 'soccer/bradford_city_fc.webp',
  },
  'US Catanzaro': {
    displayName: 'US Catanzaro',
    logoUrl: 'soccer/us_catanzaro.webp',
  },
  'BB Erzurumspor': {
    displayName: 'BB Erzurumspor',
    logoUrl: 'soccer/bb_erzurumspor.webp',
  },
  Samsunspor: {
    displayName: 'Samsunspor',
    logoUrl: 'soccer/samsunspor.webp',
  },
  'Caykur Rizespor': {
    displayName: 'Caykur Rizespor',
    logoUrl: 'soccer/caykur_rizespor.webp',
  },
  'Kasimpasa Istanbul': {
    displayName: 'Kasimpasa Istanbul',
    logoUrl: 'soccer/kasimpasa_istanbul.webp',
  },
  Corum: {
    displayName: 'Corum',
    logoUrl: 'soccer/corum.webp',
  },
  'Mantova 1911': {
    displayName: 'Mantova 1911',
    logoUrl: 'soccer/mantova_1911.webp',
  },
  'Carrarese Calcio': {
    displayName: 'Carrarese Calcio',
    logoUrl: 'soccer/carrarese_calcio.webp',
  },
  'Virtus Entella': {
    displayName: 'Virtus Entella',
    logoUrl: 'soccer/virtus_entella.webp',
  },
  'FC Sudtirol Bolzano': {
    displayName: 'FC Sudtirol Bolzano',
    logoUrl: 'soccer/fc_sudtirol_bolzano.webp',
  },
  Konyaspor: {
    displayName: 'Konyaspor',
    logoUrl: 'soccer/konyaspor.webp',
  },
  'Modena FC': {
    displayName: 'Modena FC',
    logoUrl: 'soccer/modena_fc.webp',
  },
  'Empoli FC': {
    displayName: 'Empoli FC',
    logoUrl: 'soccer/empoli_fc.webp',
  },
  'US Avellino': {
    displayName: 'US Avellino',
    logoUrl: 'soccer/us_avellino.webp',
  },
  Eldense: {
    displayName: 'Eldense',
    logoUrl: 'soccer/eldense.webp',
  },
  'Gaziantep FK': {
    displayName: 'Gaziantep FK',
    logoUrl: 'soccer/gaziantep_fk.webp',
  },
  Eyupspor: {
    displayName: 'Eyupspor',
    logoUrl: 'soccer/eyupspor.webp',
  },
  Trabzonspor: {
    displayName: 'Trabzonspor',
    logoUrl: 'soccer/trabzonspor.webp',
  },
  'Calcio Padova': {
    displayName: 'Calcio Padova',
    logoUrl: 'soccer/calcio_padova.webp',
  },
  Sabadell: {
    displayName: 'Sabadell',
    logoUrl: 'soccer/sabadell.webp',
  },
  'Genclerbirligi SK': {
    displayName: 'Genclerbirligi SK',
    logoUrl: 'soccer/genclerbirligi_sk.webp',
  },
  'Goztepe Izmir': {
    displayName: 'Goztepe Izmir',
    logoUrl: 'soccer/goztepe_izmir.webp',
  },
  Alanyaspor: {
    displayName: 'Alanyaspor',
    logoUrl: 'soccer/alanyaspor.webp',
  },
  'Sampdoria Genoa': {
    displayName: 'Sampdoria Genoa',
    logoUrl: 'soccer/sampdoria_genoa.webp',
  },
  'Cesena FC': {
    displayName: 'Cesena FC',
    logoUrl: 'soccer/cesena_fc.webp',
  },
  'Juve Stabia': {
    displayName: 'Juve Stabia',
    logoUrl: 'soccer/juve_stabia.webp',
  },
  'Palermo FC': {
    displayName: 'Palermo FC',
    logoUrl: 'soccer/palermo_fc.webp',
  },
  Tenerife: {
    displayName: 'Tenerife',
    logoUrl: 'soccer/tenerife.webp',
  },
  // Feed-name aliases pointing at existing CDN logos.
  'St. Truiden': {
    displayName: 'St. Truiden',
    logoUrl: 'soccer/st_truidense_vv.webp',
  },
  AGF: {
    displayName: 'AGF',
    logoUrl: 'soccer/agf_aarhus.webp',
  },
  PAOK: {
    displayName: 'PAOK',
    logoUrl: 'soccer/paok_fc.webp',
  },
  Monaco: {
    displayName: 'Monaco',
    logoUrl: 'soccer/as_monaco.webp',
  },
  Brighton: {
    displayName: 'Brighton',
    logoUrl: 'soccer/brighton__hove_albion.webp',
  },
  Wolverhampton: {
    displayName: 'Wolverhampton',
    logoUrl: 'soccer/wolverhampton_wanderers.webp',
  },
  Nottingham: {
    displayName: 'Nottingham',
    logoUrl: 'soccer/nottingham_forest.webp',
  },
  'Sheffield Utd': {
    displayName: 'Sheffield Utd',
    logoUrl: 'soccer/sheffield_united.webp',
  },
  'West Bromwich': {
    displayName: 'West Bromwich',
    logoUrl: 'soccer/west_bromwich_albion.webp',
  },
  'Celta Vigo B': {
    displayName: 'Celta Vigo B',
    logoUrl: 'soccer/rc_celta_de_vigo.webp',
  },
  // API-discovered soccer/all logo placeholders. Add matching CDN assets for these paths.
  Jeddeloh: {
    displayName: 'Jeddeloh',
    logoUrl: 'soccer/jeddeloh.webp',
  },
  'Schott Mainz': {
    displayName: 'Schott Mainz',
    logoUrl: 'soccer/schott_mainz.webp',
  },
  Krieschow: {
    displayName: 'Krieschow',
    logoUrl: 'soccer/krieschow.webp',
  },
  'Westfalia Rhynern': {
    displayName: 'Westfalia Rhynern',
    logoUrl: 'soccer/westfalia_rhynern.webp',
  },
  'Bahlinger SC': {
    displayName: 'Bahlinger SC',
    logoUrl: 'soccer/bahlinger_sc.webp',
  },
  'Carl Zeiss Jena': {
    displayName: 'Carl Zeiss Jena',
    logoUrl: 'soccer/carl_zeiss_jena.webp',
  },
  'Fortuna Dusseldorf': {
    displayName: 'Fortuna Dusseldorf',
    logoUrl: 'soccer/fortuna_dusseldorf.webp',
  },
  'Rot-Weiss Essen': {
    displayName: 'Rot-Weiss Essen',
    logoUrl: 'soccer/rot_weiss_essen.webp',
  },
  'Phonix Lubeck': {
    displayName: 'Phonix Lubeck',
    logoUrl: 'soccer/phonix_lubeck.webp',
  },
  Juventude: {
    displayName: 'Juventude',
    logoUrl: 'soccer/juventude.webp',
  },
  'Inter Toronto': {
    displayName: 'Inter Toronto',
    logoUrl: 'soccer/inter_toronto.webp',
  },
  Altglienicke: {
    displayName: 'Altglienicke',
    logoUrl: 'soccer/altglienicke.webp',
  },
  'Wurzburger Kickers': {
    displayName: 'Wurzburger Kickers',
    logoUrl: 'soccer/wurzburger_kickers.webp',
  },
  Verl: {
    displayName: 'Verl',
    logoUrl: 'soccer/verl.webp',
  },
  'Hallescher FC': {
    displayName: 'Hallescher FC',
    logoUrl: 'soccer/hallescher_fc.webp',
  },
  'Cardiff City': {
    displayName: 'Cardiff City',
    logoUrl: 'soccer/cardiff_city.webp',
  },
  'Doncaster Rovers': {
    displayName: 'Doncaster Rovers',
    logoUrl: 'soccer/doncaster_rovers.webp',
  },
  'Crewe Alexandra': {
    displayName: 'Crewe Alexandra',
    logoUrl: 'soccer/crewe_alexandra.webp',
  },
  'Barnsley FC': {
    displayName: 'Barnsley FC',
    logoUrl: 'soccer/barnsley_fc.webp',
  },
  'Cambridge United': {
    displayName: 'Cambridge United',
    logoUrl: 'soccer/cambridge_united.webp',
  },
  'Reading FC': {
    displayName: 'Reading FC',
    logoUrl: 'soccer/reading_fc.webp',
  },
  'Stevenage FC': {
    displayName: 'Stevenage FC',
    logoUrl: 'soccer/stevenage_fc.webp',
  },
  'Lincoln City': {
    displayName: 'Lincoln City',
    logoUrl: 'soccer/lincoln_city.webp',
  },
  'Blackpool FC': {
    displayName: 'Blackpool FC',
    logoUrl: 'soccer/blackpool_fc.webp',
  },
  'Leyton Orient London': {
    displayName: 'Leyton Orient London',
    logoUrl: 'soccer/leyton_orient_london.webp',
  },
  Walsall: {
    displayName: 'Walsall',
    logoUrl: 'soccer/walsall.webp',
  },
  'Peterborough United': {
    displayName: 'Peterborough United',
    logoUrl: 'soccer/peterborough_united.webp',
  },
  Plymouth: {
    displayName: 'Plymouth',
    logoUrl: 'soccer/plymouth.webp',
  },
  'Shrewsbury Town': {
    displayName: 'Shrewsbury Town',
    logoUrl: 'soccer/shrewsbury_town.webp',
  },
  'Fleetwood Town': {
    displayName: 'Fleetwood Town',
    logoUrl: 'soccer/fleetwood_town.webp',
  },
  'Luton Town': {
    displayName: 'Luton Town',
    logoUrl: 'soccer/luton_town.webp',
  },
  'AFC Wimbledon': {
    displayName: 'AFC Wimbledon',
    logoUrl: 'soccer/afc_wimbledon.webp',
  },
  OFI: {
    displayName: 'OFI',
    logoUrl: 'soccer/ofi.webp',
  },
  Leicester: {
    displayName: 'Leicester',
    logoUrl: 'soccer/leicester_city.webp',
  },
  Lincoln: {
    displayName: 'Lincoln',
    logoUrl: 'soccer/lincoln_city.webp',
  },
  Shrewsbury: {
    displayName: 'Shrewsbury',
    logoUrl: 'soccer/shrewsbury_town.webp',
  },
  'Plymouth Argyle': {
    displayName: 'Plymouth Argyle',
    logoUrl: 'soccer/plymouth.webp',
  },
  'Milton Keynes Dons': {
    displayName: 'Milton Keynes Dons',
    logoUrl: 'soccer/milton_keynes_dons.webp',
  },
  'Cheltenham Town': {
    displayName: 'Cheltenham Town',
    logoUrl: 'soccer/cheltenham_town.webp',
  },
  Barnet: {
    displayName: 'Barnet',
    logoUrl: 'soccer/barnet.webp',
  },
  'Port Vale': {
    displayName: 'Port Vale',
    logoUrl: 'soccer/port_vale.webp',
  },
  Chesterfield: {
    displayName: 'Chesterfield',
    logoUrl: 'soccer/chesterfield.webp',
  },
  Rotherham: {
    displayName: 'Rotherham',
    logoUrl: 'soccer/rotherham.webp',
  },
  'Bolton Wanderers': {
    displayName: 'Bolton Wanderers',
    logoUrl: 'soccer/bolton_wanderers.webp',
  },
  'Huddersfield Town': {
    displayName: 'Huddersfield Town',
    logoUrl: 'soccer/huddersfield_town.webp',
  },
  Bromley: {
    displayName: 'Bromley',
    logoUrl: 'soccer/bromley.webp',
  },
  'Burton Albion': {
    displayName: 'Burton Albion',
    logoUrl: 'soccer/burton_albion.webp',
  },
  'Notts Co': {
    displayName: 'Notts Co',
    logoUrl: 'soccer/notts_co.webp',
  },
  'Wycombe Wanderers': {
    displayName: 'Wycombe Wanderers',
    logoUrl: 'soccer/wycombe_wanderers.webp',
  },
  'Stockport County FC': {
    displayName: 'Stockport County FC',
    logoUrl: 'soccer/stockport_county_fc.webp',
  },
  'Bristol Rovers': {
    displayName: 'Bristol Rovers',
    logoUrl: 'soccer/bristol_rovers.webp',
  },
  'Crawley Town': {
    displayName: 'Crawley Town',
    logoUrl: 'soccer/crawley_town.webp',
  },
  'Accrington Stanley': {
    displayName: 'Accrington Stanley',
    logoUrl: 'soccer/accrington_stanley.webp',
  },
  'Grimsby Town': {
    displayName: 'Grimsby Town',
    logoUrl: 'soccer/grimsby_town.webp',
  },
  'Tranmere Rovers': {
    displayName: 'Tranmere Rovers',
    logoUrl: 'soccer/tranmere_rovers.webp',
  },
  'Newport County': {
    displayName: 'Newport County',
    logoUrl: 'soccer/newport_county.webp',
  },
  Rochdale: {
    displayName: 'Rochdale',
    logoUrl: 'soccer/rochdale.webp',
  },
  'Colchester United': {
    displayName: 'Colchester United',
    logoUrl: 'soccer/colchester_united.webp',
  },
  'Salford City': {
    displayName: 'Salford City',
    logoUrl: 'soccer/salford_city.webp',
  },
  'Northampton Town': {
    displayName: 'Northampton Town',
    logoUrl: 'soccer/northampton_town.webp',
  },
  Gillingham: {
    displayName: 'Gillingham',
    logoUrl: 'soccer/gillingham.webp',
  },
  'Swindon Town': {
    displayName: 'Swindon Town',
    logoUrl: 'soccer/swindon_town.webp',
  },
  'Oldham Athletic': {
    displayName: 'Oldham Athletic',
    logoUrl: 'soccer/oldham_athletic.webp',
  },
  'Exeter City': {
    displayName: 'Exeter City',
    logoUrl: 'soccer/exeter_city.webp',
  },
  'York City': {
    displayName: 'York City',
    logoUrl: 'soccer/york_city.webp',
  },
  Kocaelispor: {
    displayName: 'Kocaelispor',
    logoUrl: 'soccer/kocaelispor.webp',
  },
  Amedspor: {
    displayName: 'Amedspor',
    logoUrl: 'soccer/amedspor.webp',
  },
  'Wigan Athletic': {
    displayName: 'Wigan Athletic',
    logoUrl: 'soccer/wigan_athletic.webp',
  },
  'Mansfield Town': {
    displayName: 'Mansfield Town',
    logoUrl: 'soccer/mansfield_town.webp',
  },
};
